document.addEventListener('DOMContentLoaded', function () {
  initActivityHeroSections();
  initActivityAnchorBars();
  initActivityAnchorLinks();
  initAccessoriesSliders();
  initDropSchedules();
  initFaqAccordions();
  initProductShowcases();
  initProductDuos();
  initTutorialGrids();
  initShoppableGalleries();
  initVideoGrids();
  initTabbedProducts();
  initLensCombo();
});

function handleCartErrMsg(err) {
  if (err && err.status == 422) {
    window.Toast.show(err.message);
  }
}

function getCartParams(variantId, giftAttr) {
  let curProduct = window.getCurrentProduct(variantId, giftAttr);
  let url = '';
  let params = {};
  if (curProduct) {
    url = '/cart/change.js';
    params = {
      id: curProduct.id,
      quantity: curProduct.quantity
    }
  } else {
    url = '/cart/add.js';
    params = {
      id: variantId,
      quantity: 1,
      ...giftAttr
    }
  }
  return {
    url,
    params,
  }
}
/* =================== HeroSections ===================== */
function activityHeroNormalizeText(el) {
  return el && el.textContent
    ? String(el.textContent).replace(/\s+/g, ' ').trim()
    : '';
}

/**
 * Section context for analytics (position / category for Activity components):
 * 1) data-activity-section-title on a component root (self or any ancestor up to the same
 *    .shopify-section), when the heading is merged into section settings; else
 * 2) .section-heading__title within that .shopify-section (embedded activity-section-heading).
 */
function activityResolveActivitySectionCategory(fromEl) {
  if (!fromEl || !fromEl.closest) return '';
  var boundary = fromEl.closest('.shopify-section');
  var n = fromEl;
  while (n) {
    if (n.getAttribute) {
      var t = String(n.getAttribute('data-activity-section-title') || '').trim();
      if (t) return t;
    }
    if (n === boundary) break;
    n = n.parentElement;
  }
  if (!boundary) return '';
  var titleEl = boundary.querySelector('.section-heading__title');
  return activityHeroNormalizeText(titleEl);
}

function activityHeroPushSubscribeEvent(eventName, payload) {
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
  var data = { event: eventName };
  Object.keys(payload).forEach(function (key) {
    data[key] = payload[key];
  });
  window.dataLayer.push(data);
}

/**
 * Shopify `{% form 'customer' %}` sets posted_successfully for every customer
 * form when `?customer_posted=true`. The submitted form is the hash (form id),
 * which includes the section template id, e.g.
 * #ActivityHeroForm-template--28856965628238__comp_hero_section_BHF4eC
 */
function activityPostedCustomerFormId() {
  var posted = '';
  try {
    if (window.URLSearchParams) {
      posted = new URLSearchParams(window.location.search).get('customer_posted') || '';
    } else if (/[?&]customer_posted=true(?:&|$)/.test(String(window.location.search || ''))) {
      posted = 'true';
    }
  } catch (e) {}
  if (posted !== 'true') return '';

  var hash = String(window.location.hash || '').replace(/^#/, '');
  if (!hash) return '';
  try {
    hash = decodeURIComponent(hash);
  } catch (e) {}
  return hash.trim();
}

function activityCustomerFormPosted(form) {
  var postedId = activityPostedCustomerFormId();
  if (!postedId || !form) return false;
  var formId = String(form.id || '').trim();
  return !!(formId && postedId === formId);
}

/**
 * Activity TutorialGrid (comp-TutorialGrid):
 * - click_activity_blog_item: card / blog link
 * - click_activity_promotion: bottom CTA (e.g. LEARN MORE / EXPLORE MORE)
 */
function initTutorialGrids() {
  var roots = document.querySelectorAll('.js-tutorial-grid');
  if (!roots.length) return;

  roots.forEach(function (root) {
    bindActivityExploreMorePromotion(root);
    bindTutorialGridBlogItemTracking(root);
    initTutorialGridPagination(root);
  });
}

/**
 * TutorialGrid: track clicks on each grid card (blog item title).
 */
function bindTutorialGridBlogItemTracking(gallery) {
  if (!gallery || !gallery.classList.contains('js-tutorial-grid')) return;

  var items = gallery.querySelectorAll('.js-tutorial-grid-item');
  items.forEach(function (item) {
    if (item.dataset.tutorialBlogTrackingBound === 'true') return;
    item.dataset.tutorialBlogTrackingBound = 'true';

    function trackBlogItem() {
      var text = String(item.getAttribute('data-track-blog-title') || '').trim();
      if (!text) {
        text = activityHeroNormalizeText(item.querySelector('.tutorial-grid__card-title'));
      }
      activityHeroPushSubscribeEvent('click_activity_blog_item', { text: text });
    }

    item.addEventListener('click', trackBlogItem);
    item.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        trackBlogItem();
      }
    });
  });
}

/**
 * TutorialGrid: numbered pagination over the rendered cards.
 * Slices .tutorial-grid__card children of .tutorial-grid__list by
 * data-page-size (default 12). A pager nav is only present in the DOM
 * when there is more than one page; cards on other pages start visible
 * and are hidden here on init (progressive enhancement, no-JS shows all).
 */
function initTutorialGridPagination(root) {
  if (!root || root.dataset.tutorialPaginationBound === 'true') return;

  var list = root.querySelector('.tutorial-grid__list');
  var nav = root.querySelector('.js-tutorial-grid-pagination');
  if (!list || !nav) return;

  var cards = list.querySelectorAll('.tutorial-grid__card');
  if (!cards.length) return;

  var pageSize = parseInt(root.getAttribute('data-page-size'), 10);
  if (!pageSize || pageSize < 1) pageSize = 12;

  var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
  if (totalPages < 2) return;

  root.dataset.tutorialPaginationBound = 'true';

  var pageNumButtons = nav.querySelectorAll('.js-tutorial-page-num');
  var prevButton = nav.querySelector('.js-tutorial-page-prev');
  var nextButton = nav.querySelector('.js-tutorial-page-next');
  var currentPage = 1;

  function renderPage(page) {
    currentPage = Math.min(Math.max(1, page), totalPages);
    var from = (currentPage - 1) * pageSize;
    var to = Math.min(from + pageSize, cards.length);

    cards.forEach(function (card, index) {
      card.classList.toggle('is-hidden', index < from || index >= to);
    });

    pageNumButtons.forEach(function (button, index) {
      var isCurrent = index + 1 === currentPage;
      button.classList.toggle('is-active', isCurrent);
      if (isCurrent) {
        button.setAttribute('aria-current', 'page');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    if (prevButton) prevButton.disabled = currentPage === 1;
    if (nextButton) nextButton.disabled = currentPage === totalPages;
  }

  nav.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tutorial-page]');
    if (!button || !nav.contains(button)) return;
    var target = button.getAttribute('data-tutorial-page');
    if (target === 'prev') {
      renderPage(currentPage - 1);
    } else if (target === 'next') {
      renderPage(currentPage + 1);
    } else {
      renderPage(parseInt(target, 10));
    }
  });

  renderPage(1);
  nav.hidden = false;
}
/**
 * Shared "Explore More" CTA tracking (matches ShoppableGallery behavior).
 */
function bindActivityExploreMorePromotion(root) {
  if (!root) return;
  var exploreMore = root.querySelector('.js-activity-explore-more');
  if (!exploreMore || exploreMore.dataset.activityExplorePromotionBound === 'true') return;
  exploreMore.dataset.activityExplorePromotionBound = 'true';
  exploreMore.addEventListener('click', function () {
    var category = activityResolveActivitySectionCategory(exploreMore);
    var button_name = String(exploreMore.getAttribute('data-track-button-name') || '').trim();
    if (!button_name) button_name = activityHeroNormalizeText(exploreMore);
    activityHeroPushSubscribeEvent('click_activity_promotion', {
      category: category,
      button_name: button_name,
    });
  });
}

/**
 * Extract YouTube video id from common URL shapes.
 */
function videoGridParseYoutubeId(raw) {
  if (!raw) return '';
  var s = String(raw).trim();
  var m =
    s.match(/[?&]v=([a-zA-Z0-9_-]{11})/) ||
    s.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/) ||
    s.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/) ||
    s.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : '';
}

function videoGridParseInstagramUrl(raw) {
  try {
    var url = new URL(String(raw || '').trim());
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
    if (!/^(www\.)?instagram\.com$/i.test(url.hostname)) return '';
    if (url.username || url.password || url.port) return '';
    var match = url.pathname.match(/^\/(p|reel|reels|tv)\/([a-zA-Z0-9_-]+)(?:\/(?:embed\/)?)?$/);
    if (!match) return '';
    var type = match[1] === 'reels' ? 'reel' : match[1];
    return 'https://www.instagram.com/' + type + '/' + match[2] + '/';
  } catch (error) {
    return '';
  }
}

function initVideoGrids() {
  var roots = document.querySelectorAll('.js-video-grid');
  if (!roots.length) return;

  var activeClose = null;

  function closeActiveVideoGridModal() {
    if (typeof activeClose === 'function') activeClose();
  }

  function onModalKeydown(event) {
    if (event.key === 'Escape') {
      closeActiveVideoGridModal();
    }
  }

  roots.forEach(function (root) {
    if (root.dataset.videoGridInited === 'true') return;
    root.dataset.videoGridInited = 'true';

    bindActivityExploreMorePromotion(root);

    var modal = root.querySelector('.js-video-grid-modal');
    var modalInner = root.querySelector('.js-video-grid-modal-inner');
    var closeBtn = root.querySelector('.js-video-grid-close');
    if (!modal || !modalInner) return;

    function closeModal() {
      modal.classList.remove('video-grid__modal--visible');
      modal.setAttribute('aria-hidden', 'true');
      modalInner.innerHTML = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onModalKeydown);
      if (activeClose === closeModal) activeClose = null;
    }

    function openModal() {
      modal.classList.add('video-grid__modal--visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onModalKeydown);
      activeClose = closeModal;
    }

    function trackVideoGridItem(card) {
      var trackText = String(card.getAttribute('data-track-video-title') || '').trim();
      if (!trackText) {
        trackText = activityHeroNormalizeText(card.querySelector('.video-grid__card-title'));
      }
      if (trackText) {
        activityHeroPushSubscribeEvent('click_activity_video_item', { text: trackText });
      }
    }

    function videoGridCanOpenCard(type, yt, src, instagram) {
      if (type === 'youtube') return !!videoGridParseYoutubeId(yt);
      if (type === 'upload') return !!String(src || '').trim();
      if (type === 'instagram') return !!instagram;
      return false;
    }

    function handleCardClick(card) {
      var type = String(card.getAttribute('data-video-type') || '').trim();
      var yt = String(card.getAttribute('data-youtube-url') || '').trim();
      var src = String(card.getAttribute('data-video-src') || '').trim();
      var instagram = videoGridParseInstagramUrl(card.getAttribute('data-instagram-url'));
      if (!videoGridCanOpenCard(type, yt, src, instagram)) return;

      trackVideoGridItem(card);
      modalInner.innerHTML = '';

      if (type === 'instagram') {
        var instagramEmbed = document.createElement('div');
        instagramEmbed.className = 'video-grid__instagram';
        var instagramFrame = document.createElement('iframe');
        instagramFrame.className = 'video-grid__instagram-frame';
        instagramFrame.src = instagram + 'embed/';
        instagramFrame.title = card.getAttribute('aria-label') || 'Instagram';
        instagramFrame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        instagramFrame.setAttribute('allowfullscreen', '');
        var instagramLink = document.createElement('a');
        instagramLink.className = 'video-grid__instagram-link';
        instagramLink.href = instagram;
        instagramLink.target = '_blank';
        instagramLink.rel = 'noopener noreferrer';
        instagramLink.textContent = root.getAttribute('data-instagram-link-label') || 'Instagram';
        instagramEmbed.appendChild(instagramFrame);
        instagramEmbed.appendChild(instagramLink);
        modalInner.appendChild(instagramEmbed);
        openModal();
        return;
      }

      if (type === 'youtube') {
        var id = videoGridParseYoutubeId(yt);
        var embed = document.createElement('div');
        embed.className = 'video-grid__modal-embed video-grid__modal-embed--loading';
        var poster = document.createElement('img');
        poster.className = 'video-grid__modal-embed-poster';
        var coverImg = card.querySelector('.video-grid__cover-img');
        var coverSrc = coverImg && (coverImg.currentSrc || coverImg.getAttribute('src'));
        poster.src = coverSrc || 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
        poster.alt = '';
        poster.decoding = 'async';
        poster.loading = 'eager';
        var iframe = document.createElement('iframe');
        iframe.className = 'video-grid__modal-embed-iframe';
        iframe.setAttribute(
          'src',
          'https://www.youtube.com/embed/' +
            id +
            '?autoplay=1&rel=0&playsinline=1&modestbranding=1&iv_load_policy=3',
        );
        iframe.setAttribute('title', 'YouTube video');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        );
        iframe.setAttribute('allowfullscreen', '');
        var iframeRevealed = false;
        function finishYoutubeEmbedReveal() {
          if (iframeRevealed) return;
          iframeRevealed = true;
          embed.classList.remove('video-grid__modal-embed--loading');
          iframe.classList.add('video-grid__modal-embed-iframe--ready');
        }
        iframe.addEventListener('load', finishYoutubeEmbedReveal);
        embed.appendChild(poster);
        embed.appendChild(iframe);
        modalInner.appendChild(embed);
        openModal();
        return;
      }

      if (type === 'upload' && src) {
        var embed = document.createElement('div');
        embed.className = 'video-grid__modal-embed video-grid__modal-embed--loading';
        var coverImg = card.querySelector('.video-grid__cover-img');
        var coverSrc = coverImg && (coverImg.currentSrc || coverImg.getAttribute('src'));
        if (coverSrc) {
          var poster = document.createElement('img');
          poster.className = 'video-grid__modal-embed-poster';
          poster.src = coverSrc;
          poster.alt = '';
          poster.decoding = 'async';
          poster.loading = 'eager';
          embed.appendChild(poster);
        }
        var video = document.createElement('video');
        video.className = 'video-grid__modal-embed-iframe';
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.preload = 'auto';
        video.src = src;
        if (coverSrc) {
          video.poster = coverSrc;
        }
        var videoRevealed = false;
        function finishUploadVideoReveal() {
          if (videoRevealed) return;
          videoRevealed = true;
          embed.classList.remove('video-grid__modal-embed--loading');
          video.classList.add('video-grid__modal-embed-iframe--ready');
        }
        video.addEventListener('canplay', finishUploadVideoReveal);
        video.addEventListener('error', finishUploadVideoReveal);
        embed.appendChild(video);
        modalInner.appendChild(embed);
        video.play().catch(function () {});
        openModal();
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeModal();
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    root.querySelectorAll('.js-video-grid-card').forEach(function (card) {
      if (card.getAttribute('data-video-type') === 'instagram') {
        card.disabled = !videoGridParseInstagramUrl(card.getAttribute('data-instagram-url'));
      }
      card.addEventListener('click', function () {
        handleCardClick(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick(card);
        }
      });
    });
  });
}

function activityHeroGetTrackContext(section, form) {
  return {
    position: activityHeroNormalizeText(section.querySelector('.activity-hero__title')),
    activity_name: activityHeroNormalizeText(section.querySelector('.activity-hero__subtitle')),
    button_name: activityHeroNormalizeText(form.querySelector('.activity-hero__button-text')),
  };
}

function initActivityHeroSections() {
  var sections = document.querySelectorAll('.activity-hero-section');

  if (!sections.length) return;

  sections.forEach(function (section) {
    var form = section.querySelector('.activity-hero__form');
    if (!form) return;

    if (form.dataset.heroInited === 'true') return;
    form.dataset.heroInited = 'true';

    var emailInput = form.querySelector('.activity-hero__input');
    var agreement = form.querySelector('.activity-hero__agreement');
    var agreementCheckbox = form.querySelector('.activity-hero__agreement-checkbox');
    var submitButton = form.querySelector('.activity-hero__button');
    var emailError = form.querySelector('.activity-hero__error--email');
    var agreementError = form.querySelector('.activity-hero__error--agreement');
    var helperText = form.querySelector('.activity-hero__helper');
    var successMessage = form.querySelector('.activity-hero__success');
    var subscribeWrap = form.querySelector('.activity-hero__subscribe');

    if (successMessage && !successMessage.classList.contains('is-hidden') && activityCustomerFormPosted(form)) {
      lockSubmittedUI(savedEmail || emailInput.value || '');

      var successCopyEl = successMessage
        ? successMessage.querySelector('span:not(.activity-hero__success-icon)')
        : null;
      var successText = activityHeroNormalizeText(successCopyEl);
      var trackCtx = activityHeroGetTrackContext(section, form);
      var successEmail = String(emailInput.value || savedEmail || '').trim();
      activityHeroPushSubscribeEvent('subscribe_success', {
        position: trackCtx.position,
        activity_name: trackCtx.activity_name,
        button_name: trackCtx.button_name,
        text: successText,
        email: successEmail,
      });
      activityHeroPushSubscribeEvent('fb_subscribe_success', {
        position: trackCtx.position,
        activity_name: trackCtx.activity_name,
        button_name: trackCtx.button_name,
        text: successText,
        email: successEmail,
      });
    } else {
      showHelper();
    }

    if (!emailInput || !submitButton || !subscribeWrap) return;

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var sectionId = section.getAttribute('data-section-id') || 'default';
    var storageKey = 'activity-hero-email-' + sectionId;
    var isSubmitting = false;

    function isValidEmail(value) {
      return EMAIL_RE.test(String(value || '').trim());
    }

    function showEl(el) {
      if (!el) return;
      el.classList.remove('is-hidden');
    }

    function hideEl(el) {
      if (!el) return;
      el.classList.add('is-hidden');
    }

    function hideHelper() {
      if (!helperText) return;
      helperText.style.display = 'none';
    }

    function showHelper() {
      if (!helperText) return;

      var hasEmailError = emailError && !emailError.classList.contains('is-hidden');
      var hasAgreementError = agreementError && !agreementError.classList.contains('is-hidden');

      if (!hasEmailError && !hasAgreementError) {
        helperText.style.display = '';
      }
    }

    function safeFocus(el) {
      if (!el || typeof el.focus !== 'function') return;

      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
    }

    function showEmailError() {
      if (!emailError) return;
      emailInput.classList.add('is-error');
      showEl(emailError);
      hideHelper();
    }

    function hideEmailError() {
      emailInput.classList.remove('is-error');
      hideEl(emailError);
      showHelper();
    }

    function showAgreementError() {
      if (!agreement) return;
      agreement.classList.add('is-error', 'is-shake');
      showEl(agreementError);
      hideHelper();

      window.setTimeout(function () {
        agreement.classList.remove('is-shake');
      }, 600);
    }

    function hideAgreementError() {
      if (!agreement) return;
      agreement.classList.remove('is-error', 'is-shake');
      hideEl(agreementError);
      showHelper();
    }

    function clearErrors() {
      hideEmailError();
      hideAgreementError();
    }

    function setButtonLoading(isLoading) {
      if (!submitButton) return;

      if (isLoading) {
        submitButton.classList.add('is-loading');
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.disabled = true;
      } else {
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
      }
    }

    function blockSubmission(event) {
      if (!event) return false;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      return false;
    }

    function validateBeforeSubmit() {
      var emailValue = emailInput.value.trim();
      var needsAgreement = !!agreementCheckbox;
      var valid = true;

      clearErrors();

      if (!emailValue || !isValidEmail(emailValue)) {
        showEmailError();
        safeFocus(emailInput);
        valid = false;
      }

      if (needsAgreement && !agreementCheckbox.checked) {
        showAgreementError();

        if (valid) {
          safeFocus(agreementCheckbox);
        }

        valid = false;
      }

      return valid;
    }

    function lockSubmittedUI(emailValue) {
      subscribeWrap.classList.add('is-submitted');
      emailInput.value = emailValue || emailInput.value || '';
      emailInput.setAttribute('readonly', 'readonly');

      hideEmailError();
      hideAgreementError();
      hideHelper();

      if (successMessage) {
        successMessage.classList.remove('is-hidden');
      }
    }

    var savedEmail = '';
    try {
      savedEmail = window.sessionStorage.getItem(storageKey) || '';
    } catch (e) {}

    if (
      successMessage &&
      !successMessage.classList.contains('is-hidden') &&
      !emailInput.value &&
      savedEmail
    ) {
      emailInput.value = savedEmail;
    }

    emailInput.addEventListener('input', function () {
      var value = emailInput.value.trim();

      try {
        window.sessionStorage.setItem(storageKey, value);
      } catch (e) {}

      if (!value) {
        hideEmailError();
        return;
      }

      if (isValidEmail(value)) {
        hideEmailError();
      }
    });

    emailInput.addEventListener('blur', function () {
      var value = emailInput.value.trim();

      try {
        window.sessionStorage.setItem(storageKey, value);
      } catch (e) {}

      if (!value) {
        hideEmailError();
        return;
      }

      if (!isValidEmail(value)) {
        showEmailError();
      } else {
        hideEmailError();
      }
    });

    if (agreementCheckbox) {
      agreementCheckbox.addEventListener('change', function () {
        if (agreementCheckbox.checked) {
          hideAgreementError();
        }
      });
    }

    form.addEventListener(
      'submit',
      function (event) {
        if (isSubmitting) {
          blockSubmission(event);
          return;
        }

        var trackCtxSubmit = activityHeroGetTrackContext(section, form);
        activityHeroPushSubscribeEvent('click_subscribe', {
          position: trackCtxSubmit.position,
          activity_name: trackCtxSubmit.activity_name,
          button_name: trackCtxSubmit.button_name,
        });

        if (!validateBeforeSubmit()) {
          blockSubmission(event);
          return;
        }

        var emailValue = emailInput.value.trim();

        try {
          window.sessionStorage.setItem(storageKey, emailValue);
        } catch (e) {}

        isSubmitting = true;
        setButtonLoading(true);

        if (
          window.Shopify &&
          window.Shopify.captcha &&
          typeof window.Shopify.captcha.protect === 'function'
        ) {
          event.preventDefault();
          event.stopPropagation();

          window.Shopify.captcha.protect(form, function () {
            form.submit();
          });

          return;
        }

        form.submit();
      },
      true
    );
  });
}

/* =================== AnchorBar ===================== */
function activityGetAnchorOffset() {
  var desktop = window.innerWidth >= 1024;
  var navHeight = desktop ? 64 : 54;
  var barHeight = document.querySelector('.js-anchor-bar') ? (desktop ? 45 : 40) : 0;
  return navHeight + barHeight;
}

function activityGetAnchorTarget(targetId) {
  if (!targetId) return null;
  return document.querySelector('[data-pdp-section="' + CSS.escape(targetId) + '"]');
}

function activityScrollToAnchor(target) {
  window.scrollTo({
    top: target.getBoundingClientRect().top + window.pageYOffset - activityGetAnchorOffset(),
    behavior: 'smooth'
  });
}

function initActivityAnchorLinks() {
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a.js-drop-schedule-buy-now, a.js-activity-explore-more');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    var href = (link.getAttribute('href') || '').trim();
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var targetId;
    try {
      targetId = decodeURIComponent(href.slice(1));
    } catch (error) {
      return;
    }

    var target = activityGetAnchorTarget(targetId);
    if (!target) return;

    event.preventDefault();
    activityScrollToAnchor(target);
  });
}

function initActivityAnchorBars() {
  var bars = document.querySelectorAll('.js-anchor-bar');

  if (!bars.length) return;

  bars.forEach(function (bar) {
    if (bar.dataset.anchorInited === 'true') return;
    bar.dataset.anchorInited = 'true';

    var links = Array.prototype.slice.call(bar.querySelectorAll('.js-anchor-link'));

    if (!links.length) return;

    function clearActive() {
      links.forEach(function (link) {
        link.classList.remove('anchor-bar__link--active');
        link.removeAttribute('aria-current');
      });
    }

    function setActive(link) {
      if (!link) return;
      link.classList.add('anchor-bar__link--active');
      link.setAttribute('aria-current', 'true');
    }

    function ensureLinkVisible(link) {
      if (!link || window.innerWidth >= 1024) return;

      var pad = 16;
      var barLeft = bar.scrollLeft;
      var barRight = barLeft + bar.clientWidth;
      var linkLeft = link.offsetLeft;
      var linkRight = linkLeft + link.offsetWidth;

      if (linkLeft - pad < barLeft) {
        bar.scrollTo({
          left: Math.max(0, linkLeft - pad),
          behavior: 'smooth'
        });
      } else if (linkRight + pad > barRight) {
        bar.scrollTo({
          left: linkRight + pad - bar.clientWidth,
          behavior: 'smooth'
        });
      }
    }

    function updateActiveLink() {
      var currentLink = null;
      var offset = activityGetAnchorOffset() + 4;

      links.forEach(function (link) {
        var targetId = link.getAttribute('data-target');
        var target = activityGetAnchorTarget(targetId);

        if (!target) return;

        if (target.getBoundingClientRect().top - offset <= 0) {
          currentLink = link;
        }
      });

      clearActive();

      if (currentLink) {
        setActive(currentLink);
        ensureLinkVisible(currentLink);
      }
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var rawTab = link.getAttribute('data-tab-name');
        var tabName =
          rawTab != null && String(rawTab).length
            ? String(rawTab).replace(/\s+/g, ' ').trim()
            : activityHeroNormalizeText(link);
        if (tabName) {
          activityHeroPushSubscribeEvent('click_activity_tab', { tab_name: tabName });
        }

        var targetId = link.getAttribute('data-target');
        var target = activityGetAnchorTarget(targetId);

        if (!target) return;

        event.preventDefault();
        activityScrollToAnchor(target);

        clearActive();
        setActive(link);
        ensureLinkVisible(link);
      });
    });

    var ticking = false;

    function onScrollOrResize() {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(function () {
        updateActiveLink();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    updateActiveLink();
  });
}

/* =================== AccessoriesSlider ===================== */
function bindAccessoriesStyleCartForm(form) {
  if (form.dataset.addToCartInited === 'true') return;
  form.dataset.addToCartInited = 'true';

  var button = form.querySelector('.js-accessories-add-btn');
  var buttonText = form.querySelector('.js-accessories-add-btn-text');
  var spinner = form.querySelector('.js-accessories-add-spinner');
  var variantInput = form.querySelector('.js-accessories-variant-id');
  var giftProducts = form.querySelectorAll('.as-gift-product-id');

  if (!button || !buttonText || !variantInput) return;

  var normalText = button.getAttribute('data-normal-text') || 'ADD';
  var successText = button.getAttribute('data-success-text') || 'ADDED';

  function setIdleState() {
    button.disabled = false;
    button.classList.remove('is-loading', 'is-added', 'accessories-slider__add-btn--added');
    buttonText.textContent = normalText;
    if (spinner) spinner.hidden = true;
  }

  function setLoadingState() {
    button.disabled = true;
    button.classList.add('is-loading');
    button.classList.remove('is-added', 'accessories-slider__add-btn--added');
    buttonText.textContent = '';
    if (spinner) spinner.hidden = false;
  }

  function setSuccessState() {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.classList.add('is-added', 'accessories-slider__add-btn--added');
    buttonText.textContent = successText;
    if (spinner) spinner.hidden = true;

    window.setTimeout(function () {
      setIdleState();
    }, 1500);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (button.classList.contains('is-loading')) return;

    var variantId = variantInput.value;
    if (!variantId) return;

    setLoadingState();

    let giftAttr = {};
    let gift = {};
    let giftElems = giftProducts;
    giftElems.forEach(function(e) {
      let qty = e.dataset.stock;
      let val = e.dataset.id;
      let num = Number(qty) - window.getProductStock(variantId, val);
      if (num > 0) {
        gift[val] = num;
      }
      let giftNum = window.getGiftStock(val);
      if (giftNum >= qty) {
        gift = {};
      }
    })
    if (Object.keys(gift).length > 0) {
      giftAttr = {
        "properties": {
          "_gift": JSON.stringify(gift)
        }
      }
    }

    let { url, params } = getCartParams(variantId, giftAttr);

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(params)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw data;
          });
        }
        return response.json();
      })
      .then(function () {
        setSuccessState();

        var position = activityResolveActivitySectionCategory(form);
        var product_name = String(form.getAttribute('data-product-title') || '').trim();
        activityHeroPushSubscribeEvent('custom_add_to_cart', {
          position: position,
          product_name: product_name,
        });

        if (typeof window.pushGtmAddToCart === 'function') {
          var yhCentsAcc =
            parseInt(
              (variantInput.getAttribute('data-gtm-price-cents') ||
                variantInput.getAttribute('data-price') ||
                '0'),
              10
            ) || 0;
          var yhPriAcc = yhCentsAcc / 100;
          var yhCurAcc = window.__shopCurrencyCode || 'USD';
          window.pushGtmAddToCart({
            value: yhPriAcc,
            currency: yhCurAcc,
            items: [
              {
                item_id: String(variantId || ''),
                item_name: product_name,
                currency: yhCurAcc,
                item_brand: '',
                item_category: '',
                item_variant: '',
                price: yhPriAcc,
                quantity: 1,
                index: 1,
              },
            ],
          });
        }

        document.dispatchEvent(new CustomEvent('cart.update'));
      })
      .catch(function (error) {
        console.error('Accessories add to cart failed:', error);
        window.handleCartErrMsg(error);
        setIdleState();
      });
  });
}

function initAccessoriesSliders() {
  var sliders = document.querySelectorAll('.js-accessories-slider');

  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    if (slider.dataset.accessoriesInited === 'true') return;
    slider.dataset.accessoriesInited = 'true';

    var track = slider.querySelector('.js-accessories-track');
    var prevBtn = slider.querySelector('.js-accessories-arrow-left');
    var nextBtn = slider.querySelector('.js-accessories-arrow-right');
    var forms = slider.querySelectorAll('.js-accessories-form');

    if (!track) return;

    var isDragging = false;
    var startX = 0;
    var scrollStartLeft = 0;
    var moved = false;

    function getGap() {
      try {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 16);
      } catch (e) {
        return 16;
      }
    }

    function getScrollAmount() {
      var card = track.querySelector('.accessories-slider__card');
      if (!card) return 320;
      return card.getBoundingClientRect().width + getGap();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;

      if (window.innerWidth < 1024) {
        prevBtn.classList.add('accessories-slider__arrow--hidden');
        nextBtn.classList.add('accessories-slider__arrow--hidden');
        return;
      }

      var maxScrollLeft = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft <= 2) {
        prevBtn.classList.add('accessories-slider__arrow--hidden');
      } else {
        prevBtn.classList.remove('accessories-slider__arrow--hidden');
      }

      if (maxScrollLeft <= 0 || track.scrollLeft >= maxScrollLeft - 2) {
        nextBtn.classList.add('accessories-slider__arrow--hidden');
      } else {
        nextBtn.classList.remove('accessories-slider__arrow--hidden');
      }
    }

    function scrollTrack(direction) {
      track.scrollBy({
        left: direction * getScrollAmount(),
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollTrack(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollTrack(1);
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    window.setTimeout(updateArrows, 60);

    if (window.matchMedia('(pointer: fine)').matches) {
      track.addEventListener('mousedown', function (event) {
        if (event.target.closest('button, a, input, label, form')) return;

        isDragging = true;
        moved = false;
        startX = event.pageX;
        scrollStartLeft = track.scrollLeft;
        track.classList.add('accessories-slider__track--dragging');
      });

      track.addEventListener('mousemove', function (event) {
        if (!isDragging) return;

        var delta = startX - event.pageX;
        if (Math.abs(delta) > 4) moved = true;

        track.scrollLeft = scrollStartLeft + delta;
      });

      function stopDragging() {
        isDragging = false;
        track.classList.remove('accessories-slider__track--dragging');

        window.setTimeout(function () {
          moved = false;
        }, 0);
      }

      track.addEventListener('mouseup', stopDragging);
      track.addEventListener('mouseleave', stopDragging);

      track.addEventListener(
        'click',
        function (event) {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    forms.forEach(bindAccessoriesStyleCartForm);
    bindActivityExploreMorePromotion(slider);
  });
}

/* =================== ProductDuo ===================== */
function productDuoResolveProductName(form) {
  var card = form && form.closest ? form.closest('.product-duo__card') : null;
  if (!card) return '';
  var lm = card.querySelector('.js-product-duo-learn-more');
  if (lm) {
    var fromAttr = String(lm.getAttribute('data-product-name') || '').trim();
    if (fromAttr) return fromAttr;
  }
  return activityHeroNormalizeText(card.querySelector('.product-duo__name'));
}

function bindProductDuoCartForm(form) {
  if (!form || form.dataset.productDuoFormBound === 'true') return;
  form.dataset.productDuoFormBound = 'true';

  var button = form.querySelector('.js-product-duo-add-btn');
  var buttonText = form.querySelector('.js-product-duo-add-btn-text');
  var variantInput = form.querySelector('.js-product-duo-variant-id');

  if (!button || !buttonText || !variantInput) return;

  var normalText = button.getAttribute('data-normal-text') || 'ADD';
  var loadingText = button.getAttribute('data-loading-text') || 'ADDING...';
  var successText = button.getAttribute('data-success-text') || 'ADDED';

  function setIdleState() {
    button.disabled = false;
    button.classList.remove('is-loading', 'is-added');
    buttonText.textContent = normalText;
  }

  function setLoadingState() {
    button.disabled = true;
    button.classList.add('is-loading');
    button.classList.remove('is-added');
    buttonText.textContent = loadingText;
  }

  function setSuccessState() {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    buttonText.textContent = successText;

    window.setTimeout(function () {
      setIdleState();
    }, 1500);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (button.classList.contains('is-loading')) return;

    var variantId = variantInput.value;
    if (!variantId) return;

    setLoadingState();
    let gift = {};
    let giftAttr = {};
    let giftElems = form.querySelectorAll('.as-gift-product-id');
    giftElems.forEach(function(e) {
      let qty = e.dataset.stock;
      let val = e.dataset.id;
      let num = Number(qty) - window.getProductStock(variantId, val);
      if (num > 0) {
        gift[val] = num;
      }

      let giftNum = window.getGiftStock(val);
      if (giftNum >= qty) {
        gift = {};
      }
    })
    if (Object.keys(gift).length > 0) {
      giftAttr = {
        "properties": {
          "_gift": JSON.stringify(gift)
        }
      }
    }

    let { url, params } = getCartParams(variantId, giftAttr);
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(params)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw data;
          });
        }
        return response.json();
      })
      .then(function () {
        var position = activityResolveActivitySectionCategory(form);
        var product_name = productDuoResolveProductName(form) || '';
        activityHeroPushSubscribeEvent('custom_add_to_cart', {
          position: position,
          product_name: product_name,
        });

        if (typeof window.pushGtmAddToCart === 'function') {
          var yhCents =
            parseInt(
              (variantInput.getAttribute('data-gtm-price-cents') ||
                variantInput.getAttribute('data-price') ||
                '0'),
              10
            ) || 0;
          var yhPri = yhCents / 100;
          var yhCur = window.__shopCurrencyCode || 'USD';
          window.pushGtmAddToCart({
            value: yhPri,
            currency: yhCur,
            items: [
              {
                item_id: String(variantId || ''),
                item_name: product_name,
                currency: yhCur,
                item_brand: '',
                item_category: '',
                item_variant: '',
                price: yhPri,
                quantity: 1,
                index: 1,
              },
            ],
          });
        }

        document.dispatchEvent(new CustomEvent('cart.update'));
        setSuccessState();
      })
      .catch(function (error) {
        window.handleCartErrMsg(error);
        console.error('ProductDuo add to cart failed:', error);
        setIdleState();
      });
  });
}

function initProductDuos() {
  var roots = document.querySelectorAll('.js-product-duo');

  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.productDuoInited === 'true') return;
    root.dataset.productDuoInited = 'true';

    var learnMoreLinks = root.querySelectorAll('.js-product-duo-learn-more');
    learnMoreLinks.forEach(function (link) {
      if (link.dataset.productDuoLearnTrackBound === 'true') return;
      link.dataset.productDuoLearnTrackBound = 'true';
      link.addEventListener('click', function () {
        var position = activityResolveActivitySectionCategory(link);
        var product_name = String(link.getAttribute('data-product-name') || '').trim();

        activityHeroPushSubscribeEvent('click_activity_learn_more', {
          position: position,
          product_name: product_name,
        });
      });
    });

    var accessoryForms = root.querySelectorAll('.js-accessories-form');
    accessoryForms.forEach(bindAccessoriesStyleCartForm);

    root.querySelectorAll('.js-product-duo-form').forEach(bindProductDuoCartForm);

    bindActivityExploreMorePromotion(root);
  });
}

/* =================== FAQ Accordion ===================== */
function initFaqAccordions() {
  var sections = document.querySelectorAll('.js-faq-accordion-section');

  if (!sections.length) return;

  sections.forEach(function (section) {
    if (section.dataset.faqInited === 'true') return;
    section.dataset.faqInited = 'true';

    var items = section.querySelectorAll('.faq-accordion__item');

    items.forEach(function (item) {
      var button = item.querySelector('.js-faq-question');
      var answer = item.querySelector('.faq-accordion__answer-wrapper');

      if (!button || !answer) return;

      function openItem() {
        button.setAttribute('aria-expanded', 'true');
        answer.hidden = false;

        var icon = button.querySelector('.faq-accordion__icon');
        if (icon) icon.textContent = '−';

        window.requestAnimationFrame(function () {
          answer.classList.add('faq-accordion__answer-wrapper--open');
        });
      }

      function closeItem() {
        button.setAttribute('aria-expanded', 'false');
        answer.classList.remove('faq-accordion__answer-wrapper--open');

        var icon = button.querySelector('.faq-accordion__icon');
        if (icon) icon.textContent = '+';

        window.setTimeout(function () {
          if (button.getAttribute('aria-expanded') === 'false') {
            answer.hidden = true;
          }
        }, 280);
      }

      button.addEventListener('click', function () {
        var isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closeItem();
        } else {
          openItem();
        }
      });
    });

    var termsLinks = section.querySelectorAll('.faq-accordion__terms-link');
    termsLinks.forEach(function (link) {
      if (link.dataset.termsConditionTrackBound === 'true') return;
      link.dataset.termsConditionTrackBound = 'true';
      link.addEventListener('click', function () {
        var button_name = activityHeroNormalizeText(link);
        activityHeroPushSubscribeEvent('click_terms_condition', {
          button_name: button_name,
        });
      });
    });
  });
}

/* =================== DropSchedule ===================== */
/**
 * Text as the user sees it: collapse whitespace and honor CSS text-transform
 * (e.g. subscribe title / button use uppercase in activity.css).
 */
function dropScheduleElementDisplayText(el) {
  if (!el) return '';
  var raw = String(el.textContent || '').replace(/\s+/g, ' ').trim();
  if (!raw) return '';
  if (typeof window.getComputedStyle !== 'function') return raw;
  var t = window.getComputedStyle(el).textTransform;
  if (t === 'uppercase') return raw.toUpperCase();
  if (t === 'lowercase') return raw.toLowerCase();
  if (t === 'capitalize') {
    return raw.replace(/(^|\s)\S/g, function (m) {
      return m.toUpperCase();
    });
  }
  return raw;
}

function dropScheduleUppercaseLabel(raw) {
  return String(raw || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

function dropSchedulePlainLabel(raw) {
  return String(raw || '')
    .replace(/\s+/g, ' ')
    .trim();
}

function dropScheduleSubscribeAnalyticsContext(section, subscribeForm) {
  var titleEl = section.querySelector('.drop-schedule__subscribe-title');
  var descEl = section.querySelector('.drop-schedule__subscribe-desc');
  var btnEl = subscribeForm ? subscribeForm.querySelector('.drop-schedule__subscribe-btn-text') : null;
  var heroSubtitleEl = document.querySelector('.activity-hero__title');
  var titleFallback = (section.getAttribute('data-drop-analytics-title') || '').trim();
  var btnFallback = (section.getAttribute('data-drop-analytics-button') || '').trim();
  var descFallback = (section.getAttribute('data-drop-analytics-desc') || '').trim();

  var position = dropScheduleElementDisplayText(titleEl) || dropScheduleUppercaseLabel(titleFallback);
  var button_name = dropScheduleElementDisplayText(btnEl) || dropScheduleUppercaseLabel(btnFallback);
  var activity_name =
    dropScheduleElementDisplayText(heroSubtitleEl) ||
    dropScheduleElementDisplayText(descEl) ||
    dropSchedulePlainLabel(descFallback);

  return {
    position: position,
    activity_name: activity_name,
    button_name: button_name,
  };
}

function initDropSchedules() {
  var sections = document.querySelectorAll('.js-drop-schedule');
  if (!sections.length) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function isValidEmail(value) {
    return EMAIL_RE.test(String(value || '').trim());
  }

  function showEl(el) {
    if (!el) return;
    el.classList.remove('is-hidden');
  }

  function hideEl(el) {
    if (!el) return;
    el.classList.add('is-hidden');
  }

  function setLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.classList.remove('is-loading');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
  }

  function lockBody() {
    document.body.classList.add('drop-schedule-modal-open');
  }

  function unlockBody() {
    document.body.classList.remove('drop-schedule-modal-open');
  }

  function ensureSubscribeSuccessEl(form) {
    if (!form) return null;

    var successEl = form.querySelector('.js-drop-schedule-subscribe-success');
    if (!successEl) {
      successEl = document.createElement('p');
      successEl.className = 'drop-schedule__subscribe-success is-hidden js-drop-schedule-subscribe-success';
      successEl.textContent = 'Subscribed! We will notify you before the event starts.';
      form.appendChild(successEl);
    }

    return successEl;
  }

  function ensureSubscribeStateWrap(form) {
    if (!form) return null;

    var stateWrap = form.querySelector('.js-drop-schedule-subscribe-state');
    if (stateWrap) return stateWrap;

    var successEl = form.querySelector('.js-drop-schedule-subscribe-success');
    stateWrap = document.createElement('div');
    stateWrap.className = 'js-drop-schedule-subscribe-state';

    Array.prototype.slice.call(form.children).forEach(function (child) {
      if (child !== successEl) {
        stateWrap.appendChild(child);
      }
    });

    form.insertBefore(stateWrap, successEl || null);
    return stateWrap;
  }

  function clearInputError(input, errorEl) {
    if (input) input.classList.remove('is-error');
    hideEl(errorEl);
  }

  function setInputError(input, errorEl) {
    if (input) input.classList.add('is-error');
    showEl(errorEl);
  }

  sections.forEach(function (section) {
    if (section.dataset.dropScheduleInited === 'true') return;
    section.dataset.dropScheduleInited = 'true';

    var dropScheduleSectionId = String(section.getAttribute('data-section-id') || '').trim();
    var subscribeEmailKey = 'activity-drop-schedule-subscribe-email-' + dropScheduleSectionId;
    var subscribeCheckedKey = 'activity-drop-schedule-subscribe-checked-' + dropScheduleSectionId;
    var subscribeShowPrivacyErrorKey =
      'activity-drop-schedule-subscribe-show-privacy-error-' + dropScheduleSectionId;
    var subscribeShowEmailErrorKey =
      'activity-drop-schedule-subscribe-show-email-error-' + dropScheduleSectionId;
    var modalOpenKey = 'activity-drop-schedule-modal-open-' + dropScheduleSectionId;
    var modalEmailKey = 'activity-drop-schedule-modal-email-' + dropScheduleSectionId;
    var modalShowEmailErrorKey = 'activity-drop-schedule-modal-show-email-error-' + dropScheduleSectionId;
    var modalShowPrivacyErrorKey =
      'activity-drop-schedule-modal-show-privacy-error-' + dropScheduleSectionId;

    var phase = section.getAttribute('data-phase') || 'warmup';
    var grid = section.querySelector('.drop-schedule__grid');

    function scrollLiveCardIntoView() {
      if (!grid || phase !== 'live' || window.innerWidth >= 768) return;

      var liveCard = grid.querySelector('[data-drop-live="true"]');
      if (!liveCard) return;

      window.requestAnimationFrame(function () {
        if (typeof liveCard.scrollIntoView === 'function') {
          liveCard.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'instant'
          });
        }
      });
    }

    scrollLiveCardIntoView();
    window.addEventListener('resize', scrollLiveCardIntoView);

    section.addEventListener('click', function (event) {
      var buyEl = event.target.closest('.js-drop-schedule-buy-now');
      if (!buyEl || !section.contains(buyEl)) return;
      var productName = buyEl.getAttribute('data-product-name') || '';
      activityHeroPushSubscribeEvent('click_activity_buy_now', {
        product_name: productName,
      });
    });

    /* ---------------- warmup subscribe ---------------- */
    var subscribeForm = section.querySelector('.js-drop-schedule-subscribe-form');

    if (subscribeForm) {
      var subscribeInput = subscribeForm.querySelector('.js-drop-schedule-subscribe-input');
      var subscribeCheckbox = subscribeForm.querySelector('.js-drop-schedule-subscribe-checkbox');
      var subscribeEmailError = subscribeForm.querySelector('.js-drop-schedule-subscribe-email-error');
      var subscribePrivacyError = subscribeForm.querySelector('.js-drop-schedule-subscribe-privacy-error');
      var subscribeBtn = subscribeForm.querySelector('.js-drop-schedule-subscribe-btn');

      ensureSubscribeStateWrap(subscribeForm);

      if (activityCustomerFormPosted(subscribeForm)) {
        sessionStorage.removeItem(subscribeShowPrivacyErrorKey);
        sessionStorage.removeItem(subscribeShowEmailErrorKey);

        var successCopy = dropScheduleElementDisplayText(subscribeForm.querySelector('.drop-schedule__subscribe-success'));
        var savedSubscribeEmail = sessionStorage.getItem(subscribeEmailKey) || '';
        var trackSubscribeOk = dropScheduleSubscribeAnalyticsContext(section, subscribeForm);
        activityHeroPushSubscribeEvent('subscribe_success', {
          position: trackSubscribeOk.position,
          activity_name: trackSubscribeOk.activity_name,
          button_name: trackSubscribeOk.button_name,
          text: successCopy,
          email: String(savedSubscribeEmail).trim(),
        });
        activityHeroPushSubscribeEvent('fb_subscribe_success', {
          position: trackSubscribeOk.position,
          activity_name: trackSubscribeOk.activity_name,
          button_name: trackSubscribeOk.button_name,
          text: successCopy,
          email: String(savedSubscribeEmail).trim(),
        });
      }      

      if (subscribeInput) {
        subscribeInput.addEventListener('input', function () {
          var value = subscribeInput.value.trim();

          if (!value) {
            clearInputError(subscribeInput, subscribeEmailError);
            return;
          }

          if (isValidEmail(value)) {
            clearInputError(subscribeInput, subscribeEmailError);
          }
        });

        subscribeInput.addEventListener('focus', function () {
          subscribeInput.classList.add('is-focus');
        });

        subscribeInput.addEventListener('blur', function () {
          subscribeInput.classList.remove('is-focus');

          var value = subscribeInput.value.trim();

          if (!value) {
            clearInputError(subscribeInput, subscribeEmailError);
            return;
          }

          if (!isValidEmail(value)) {
            setInputError(subscribeInput, subscribeEmailError);
          } else {
            clearInputError(subscribeInput, subscribeEmailError);
          }
        });
      }

      if (subscribeCheckbox) {
        subscribeCheckbox.addEventListener('change', function () {
          if (subscribeCheckbox.checked) {
            hideEl(subscribePrivacyError);
          }
        });
      }

      subscribeForm.addEventListener('submit', function (event) {
        var trackSubscribeClick = dropScheduleSubscribeAnalyticsContext(section, subscribeForm);
        activityHeroPushSubscribeEvent('click_subscribe', {
          position: trackSubscribeClick.position,
          activity_name: trackSubscribeClick.activity_name,
          button_name: trackSubscribeClick.button_name,
        });

        var emailValue = subscribeInput ? subscribeInput.value.trim() : '';
        var hasError = false;

        clearInputError(subscribeInput, subscribeEmailError);
        hideEl(subscribePrivacyError);

        if (!emailValue || !isValidEmail(emailValue)) {
          hasError = true;
          setInputError(subscribeInput, subscribeEmailError);
        }

        if (subscribeCheckbox && !subscribeCheckbox.checked) {
          hasError = true;
          showEl(subscribePrivacyError);
        }

        if (hasError) {
          event.preventDefault();

          if (subscribeInput && (!emailValue || !isValidEmail(emailValue))) {
            subscribeInput.focus();
          } else if (subscribeCheckbox && !subscribeCheckbox.checked) {
            subscribeCheckbox.focus();
          }

          setLoading(subscribeBtn, false);
          return;
        }

        sessionStorage.setItem(subscribeEmailKey, emailValue);
        sessionStorage.setItem(subscribeCheckedKey, subscribeCheckbox && subscribeCheckbox.checked ? 'true' : 'false');

        setLoading(subscribeBtn, true);
      });
    }

    /* notify modal */
    var firstTrigger = section.querySelector('.js-drop-schedule-notify-trigger');
    if (!firstTrigger) return;

    var modalId = firstTrigger.getAttribute('data-modal-target');
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    if (!modal) return;

    var modalSuccessServer = modal.querySelector('.js-drop-schedule-modal-server-success');

    var modalClose = modal.querySelector('.js-drop-schedule-modal-close');
    var modalForm = modal.querySelector('.js-drop-schedule-modal-form');
    var modalInput = modal.querySelector('.js-drop-schedule-modal-input');
    var modalCheckbox = modal.querySelector('.js-drop-schedule-modal-checkbox');
    var modalError = modal.querySelector('.js-drop-schedule-modal-error');
    var modalSubmit = modal.querySelector('.js-drop-schedule-modal-submit');
    var notifyTriggers = section.querySelectorAll('.js-drop-schedule-notify-trigger');

    function getOrCreateModalSuccess() {
      var success = modal.querySelector('.js-drop-schedule-modal-success');

      if (!success) {
        success = document.createElement('div');
        success.className = 'drop-schedule__modal-success is-hidden js-drop-schedule-modal-success';
        success.innerHTML =
          '<div class="drop-schedule__modal-success-text">Reminder Set!</div>' +
          '<div class="drop-schedule__modal-success-sub">We will notify you before this drop goes live.</div>';

        modal.appendChild(success);
      }

      return success;
    }

    var modalSuccess = getOrCreateModalSuccess();

    function resetModalState() {
      if (modalForm) {
        modalForm.reset();
        showEl(modalForm);
      }

      if (modalInput) {
        modalInput.classList.remove('is-error');
        modalInput.classList.remove('is-focus');
      }

      hideEl(modalError);
      hideEl(modalSuccess);

      if (modalSubmit) {
        setLoading(modalSubmit, false);
      }
    }

    function openModal() {
      resetModalState();

      modal.setAttribute('aria-hidden', 'false');
      showEl(modal);
      lockBody();

      if (modalInput) {
        window.setTimeout(function () {
          modalInput.focus();
        }, 30);
      }
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      hideEl(modal);
      unlockBody();
    }

    notifyTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal();
      });
    });

    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.classList.contains('is-hidden')) {
        closeModal();
      }
    });

    if (modalInput) {
      modalInput.addEventListener('focus', function () {
        modalInput.classList.add('is-focus');
      });

      modalInput.addEventListener('input', function () {
        var value = modalInput.value.trim();

        if (!value) {
          modalInput.classList.remove('is-error');
          hideEl(modalError);
          return;
        }

        if (isValidEmail(value)) {
          modalInput.classList.remove('is-error');
          hideEl(modalError);
        }
      });

      modalInput.addEventListener('blur', function () {
        modalInput.classList.remove('is-focus');

        var value = modalInput.value.trim();

        if (!value) {
          modalInput.classList.remove('is-error');
          hideEl(modalError);
          return;
        }

        if (!isValidEmail(value)) {
          modalInput.classList.add('is-error');
          if (modalError) {
            modalError.textContent = 'Please enter a valid email address.';
          }
          showEl(modalError);
        } else {
          modalInput.classList.remove('is-error');
          hideEl(modalError);
        }
      });
    }

    if (modalCheckbox) {
      modalCheckbox.addEventListener('change', function () {
        if (modalCheckbox.checked && modalError && modalError.dataset.errorType === 'privacy') {
          hideEl(modalError);
          delete modalError.dataset.errorType;
        }
      });
    }

    if (modalForm) {
      modalForm.addEventListener('submit', function (event) {
        activityHeroPushSubscribeEvent('click_notify_me', {});

        var emailValue = modalInput ? modalInput.value.trim() : '';
        var hasError = false;

        if (modalInput) {
          modalInput.classList.remove('is-error');
        }

        hideEl(modalError);

        if (!emailValue || !isValidEmail(emailValue)) {
          hasError = true;

          if (modalInput) {
            modalInput.classList.add('is-error');
          }

          if (modalError) {
            modalError.textContent = 'Please enter a valid email address.';
            modalError.dataset.errorType = 'email';
          }

          showEl(modalError);
        }

        if (modalCheckbox && !modalCheckbox.checked) {
          hasError = true;

          if (modalError && (!emailValue || isValidEmail(emailValue))) {
            modalError.textContent = 'Please agree to the Privacy Policy.';
            modalError.dataset.errorType = 'privacy';
            showEl(modalError);
          }
        }

        if (hasError) {
          event.preventDefault();

          if (modalInput && (!emailValue || !isValidEmail(emailValue))) {
            modalInput.focus();
          } else if (modalCheckbox && !modalCheckbox.checked) {
            modalCheckbox.focus();
          }

          setLoading(modalSubmit, false);
          return;
        }

        setLoading(modalSubmit, true);
      });
    }

    var shouldReopenModal = sessionStorage.getItem(modalOpenKey) === 'true';

    if (shouldReopenModal) {
      openModal('', '');
    }

    if (modalSuccessServer) {
      showEl(modal);
      modal.setAttribute('aria-hidden', 'false');
      lockBody();

      sessionStorage.removeItem(modalOpenKey);
      sessionStorage.removeItem(modalShowEmailErrorKey);
      sessionStorage.removeItem(modalShowPrivacyErrorKey);

      var notifySuccessText = activityHeroNormalizeText(modalSuccessServer);
      var savedNotifyEmail = sessionStorage.getItem(modalEmailKey) || '';
      activityHeroPushSubscribeEvent('notify_me_success', {
        text: notifySuccessText,
        email: String(savedNotifyEmail).trim(),
      });
    }
  });
}

/* =================== ProductShowcase ===================== */
function productShowcaseGetAnalyticsContext(showcase, el) {
  var position = activityResolveActivitySectionCategory(showcase);
  var product_name =
    el && el.getAttribute
      ? String(el.getAttribute('data-product-name') || '').trim()
      : '';
  return { position: position, product_name: product_name };
}

function initProductShowcases() {
  var showcases = document.querySelectorAll('.js-product-showcase');
  if (!showcases.length) return;

  function closeAllTooltips(scope) {
    var tooltipToggles = (scope || document).querySelectorAll('.js-product-showcase-badge-tip');
    tooltipToggles.forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-expanded', 'false');
    });
  }

  function bindTooltip(toggle, scope) {
    if (!toggle || toggle.dataset.tooltipBound === 'true') return;
    toggle.dataset.tooltipBound = 'true';

    var tooltip = toggle.querySelector('.product-showcase__tooltip');
    if (!tooltip) return;

    function openTooltip() {
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeTooltip() {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('mouseenter', openTooltip);
    toggle.addEventListener('mouseleave', closeTooltip);
    toggle.addEventListener('focus', openTooltip);
    toggle.addEventListener('blur', closeTooltip);

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var isOpen = toggle.classList.contains('is-active');
      closeAllTooltips(scope);

      if (!isOpen) {
        openTooltip();
      }
    });
  }

  function refreshCartCountAndNotify() {
    document.dispatchEvent(new CustomEvent('cart.update'));
    return Promise.resolve();
  }

  showcases.forEach(function (showcase) {
    if (showcase.dataset.productShowcaseInited === 'true') return;
    showcase.dataset.productShowcaseInited = 'true';

    var addBtn = showcase.querySelector('.js-product-showcase-add-btn');
    var errorBox = showcase.querySelector('.js-product-showcase-cart-error');
    var tooltipToggles = showcase.querySelectorAll('.js-product-showcase-badge-tip');

    tooltipToggles.forEach(function (toggle) {
      bindTooltip(toggle, showcase);
    });

    document.addEventListener('click', function (event) {
      if (showcase.contains(event.target)) return;
      closeAllTooltips(showcase);
    });

    var learnMoreLinks = showcase.querySelectorAll('.js-product-showcase-learn-more');
    learnMoreLinks.forEach(function (link) {
      if (link.dataset.learnMoreTrackBound === 'true') return;
      link.dataset.learnMoreTrackBound = 'true';
      link.addEventListener('click', function () {
        var ctx = productShowcaseGetAnalyticsContext(showcase, link);
        activityHeroPushSubscribeEvent('click_activity_learn_more', {
          position: ctx.position,
          product_name: ctx.product_name,
        });
      });
    });

    if (!addBtn) return;

    var variantId = addBtn.getAttribute('data-variant-id');
    var defaultLabel = addBtn.getAttribute('data-default-label') || 'ADD TO CART';
    var loadingLabel = addBtn.getAttribute('data-loading-label') || 'ADDING...';
    var successLabel = addBtn.getAttribute('data-success-label') || 'ADDED ✓';
    var soldoutLabel = addBtn.getAttribute('data-soldout-label') || 'OUT OF STOCK';
    var retryLabel = addBtn.getAttribute('data-retry-label') || 'RETRY';
    var errorLabel =
      addBtn.getAttribute('data-error-label') || 'Failed to add to cart. Please try again.';

    function hideError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.hidden = false;
      errorBox.textContent = message || errorLabel;
    }

    function setState(state) {
      addBtn.classList.remove(
        'product-showcase__btn--loading',
        'product-showcase__btn--success',
        'product-showcase__btn--soldout',
        'product-showcase__btn--error'
      );

      if (state === 'loading') {
        addBtn.classList.add('product-showcase__btn--loading');
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.textContent = loadingLabel;
        return;
      }

      if (state === 'success') {
        addBtn.classList.add('product-showcase__btn--success');
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.textContent = successLabel;
        return;
      }

      if (state === 'soldout') {
        addBtn.classList.add('product-showcase__btn--soldout');
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.textContent = soldoutLabel;
        return;
      }

      if (state === 'error') {
        addBtn.classList.add('product-showcase__btn--error');
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.textContent = retryLabel;
        return;
      }

      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
      addBtn.textContent = defaultLabel;
    }

    hideError();

    if (!variantId || addBtn.classList.contains('product-showcase__btn--soldout')) {
      setState('soldout');
      return;
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;

      if (!variantId) {
        setState('soldout');
        return;
      }

      hideError();
      setState('loading');

      let gift = {};
      let giftAttr = {};
      let giftElems = showcase.querySelectorAll('.as-gift-product-id');
      giftElems.forEach(function(e) {
        let qty = e.dataset.stock;
        let val = e.dataset.id;
        let num = Number(qty) - window.getProductStock(variantId, val);
        if (num > 0) {
          gift[val] = num;
        }
        let giftNum = window.getGiftStock(val);
        if (giftNum >= qty) {
          gift = {};
        }
      })
      if (Object.keys(gift).length > 0) {
        giftAttr = {
          "properties": {
            "_gift": JSON.stringify(gift)
          }
        }
      }

      let { url, params } = getCartParams(variantId, giftAttr);

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(params)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw data;
            });
          }
          return response.json();
        })
        .then(function () {
          return refreshCartCountAndNotify().then(function () {
            setState('success');

          var ctxCart = productShowcaseGetAnalyticsContext(showcase, addBtn);
          activityHeroPushSubscribeEvent('custom_add_to_cart', {
            position: ctxCart.position,
            product_name: ctxCart.product_name,
          });

          if (typeof window.pushGtmAddToCart === 'function') {
            var yhCentsShow = parseInt(addBtn.getAttribute('data-gtm-price-cents') || '0', 10) || 0;
            var yhPriShow = yhCentsShow / 100;
            var yhCurShow = window.__shopCurrencyCode || 'USD';
            window.pushGtmAddToCart({
              value: yhPriShow,
              currency: yhCurShow,
              items: [
                {
                  item_id: String(variantId || ''),
                  item_name: ctxCart.product_name || '',
                  currency: yhCurShow,
                  item_brand: '',
                  item_category: '',
                  item_variant: '',
                  price: yhPriShow,
                  quantity: 1,
                  index: 1,
                },
              ],
            });
          }

          window.setTimeout(function () {
            hideError();
            setState('idle');
          }, 1500);
        });
        })
        .catch(function (error) {
          window.handleCartErrMsg(error);
          setState('error');
        });
    });
  });
}

/* =================== ShoppableGallery ===================== */
function initShoppableGalleries() {
  var galleries = document.querySelectorAll('.js-shoppable-gallery');

  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    if (gallery.dataset.shoppableInited === 'true') return;
    gallery.dataset.shoppableInited = 'true';

    bindActivityExploreMorePromotion(gallery);

    var dataEl = gallery.querySelector('.js-shoppable-gallery-data');
    var items = gallery.querySelectorAll('.js-shoppable-gallery-item');
    var overlay = gallery.querySelector('.js-shoppable-gallery-overlay');
    var modal = gallery.querySelector('.js-shoppable-gallery-modal');
    var closeBtn = gallery.querySelector('.js-shoppable-gallery-close');
    var modalImg = gallery.querySelector('.js-shoppable-gallery-modal-img');
    var modalPlaceholder = gallery.querySelector('.js-shoppable-gallery-modal-placeholder');
    var productsWrap = gallery.querySelector('.js-shoppable-gallery-products');
    var footer = gallery.querySelector('.js-shoppable-gallery-footer');
    var addAllBtn = gallery.querySelector('.js-shoppable-gallery-add-all-btn');
    var addAllError = gallery.querySelector('.js-shoppable-gallery-add-all-error');
    var titleEl = gallery.querySelector('.shoppable-gallery__modal-title');
    var descEl = gallery.querySelector('.shoppable-gallery__modal-subtitle');

    var i18nAdd = gallery.dataset.i18nAdd || 'Add';
    var i18nAdding = gallery.dataset.i18nAdding || 'ADDING...';
    var i18nAdded = gallery.dataset.i18nAdded || 'Added';
    var i18nSoldOut = gallery.dataset.i18nSoldOut || 'Sold Out';

    if (!dataEl || !overlay || !modal || !productsWrap || !modalImg) {
      return;
    }

    function shoppableGalleryTrackingPosition() {
      return activityResolveActivitySectionCategory(gallery);
    }

    var galleryData = [];

    try {
      galleryData = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('ShoppableGallery JSON parse error:', error);
      return;
    }

    var activeIndex = null;
    var isClosing = false;
    var bodyOriginalOverflow = '';

    function lockBody() {
      bodyOriginalOverflow = document.body.style.overflow || '';
      document.body.style.overflow = 'hidden';
    }

    function unlockBody() {
      document.body.style.overflow = bodyOriginalOverflow;
    }

    function createSpinner() {
      var spinner = document.createElement('span');
      spinner.className = 'shoppable-gallery__modal-add-spinner';
      return spinner;
    }

    function setButtonText(button, text) {
      if (!button) return;
      button.innerHTML = '';

      var textSpan = document.createElement('span');
      textSpan.className = 'js-shoppable-gallery-add-btn-text';
      textSpan.textContent = text;
      button.appendChild(textSpan);
    }

    function setButtonLoading(button, text) {
      if (!button) return;

      button.disabled = true;
      button.classList.remove(
        'shoppable-gallery__modal-add-btn--success',
        'shoppable-gallery__modal-add-btn--error',
        'shoppable-gallery__modal-add-btn--soldout'
      );
      button.classList.add('shoppable-gallery__modal-add-btn--loading');
      button.innerHTML = '';
      button.appendChild(createSpinner());

      if (text) {
        var textSpan = document.createElement('span');
        textSpan.className = 'js-shoppable-gallery-add-btn-text';
        textSpan.style.marginLeft = '6px';
        textSpan.textContent = text;
        button.appendChild(textSpan);
      }
    }

    function resetSingleButton(button, soldOut) {
      if (!button) return;

      button.classList.remove(
        'shoppable-gallery__modal-add-btn--loading',
        'shoppable-gallery__modal-add-btn--success',
        'shoppable-gallery__modal-add-btn--error'
      );

      if (soldOut) {
        button.disabled = true;
        button.classList.add('shoppable-gallery__modal-add-btn--soldout');
        setButtonText(button, i18nSoldOut);
      } else {
        button.disabled = false;
        button.classList.remove('shoppable-gallery__modal-add-btn--soldout');
        setButtonText(button, i18nAdd);
      }
    }

    function setSingleButtonSuccess(button) {
      if (!button) return;

      button.disabled = false;
      button.classList.remove(
        'shoppable-gallery__modal-add-btn--loading',
        'shoppable-gallery__modal-add-btn--error'
      );
      button.classList.add('shoppable-gallery__modal-add-btn--success');
      setButtonText(button, i18nAdded);
    }

    function setSingleButtonError(button) {
      if (!button) return;

      button.disabled = false;
      button.classList.remove(
        'shoppable-gallery__modal-add-btn--loading',
        'shoppable-gallery__modal-add-btn--success'
      );
      button.classList.add('shoppable-gallery__modal-add-btn--error');
      setButtonText(button, i18nAdd);
    }

    function getAddAllDefaultLabel() {
      if (!addAllBtn) return 'Add All to Cart';
      return addAllBtn.getAttribute('data-default-label') || 'Add All to Cart';
    }

    function getAddAllSuccessLabel() {
      if (!addAllBtn) return 'All Added';
      return addAllBtn.getAttribute('data-success-label') || 'All Added';
    }

    function getAddAllErrorLabel() {
      if (!addAllBtn) return 'Add All to Cart';
      return addAllBtn.getAttribute('data-error-label') || getAddAllDefaultLabel();
    }

    function setAddAllIdle() {
      if (!addAllBtn) return;

      addAllBtn.disabled = false;
      addAllBtn.classList.remove(
        'shoppable-gallery__modal-add-all-btn--loading',
        'shoppable-gallery__modal-add-all-btn--success',
        'shoppable-gallery__modal-add-all-btn--error'
      );
      addAllBtn.innerHTML = getAddAllDefaultLabel();

      if (addAllError) addAllError.hidden = true;
    }

    function setAddAllLoading() {
      if (!addAllBtn) return;

      addAllBtn.disabled = true;
      addAllBtn.classList.remove(
        'shoppable-gallery__modal-add-all-btn--success',
        'shoppable-gallery__modal-add-all-btn--error'
      );
      addAllBtn.classList.add('shoppable-gallery__modal-add-all-btn--loading');
      addAllBtn.innerHTML = '';
      addAllBtn.appendChild(createSpinner());

      var textSpan = document.createElement('span');
      textSpan.className = 'js-shoppable-gallery-add-all-btn-text';
      textSpan.style.marginLeft = '6px';
      textSpan.textContent = getAddAllDefaultLabel();
      addAllBtn.appendChild(textSpan);

      if (addAllError) addAllError.hidden = true;
    }

    function setAddAllSuccess() {
      if (!addAllBtn) return;

      addAllBtn.disabled = false;
      addAllBtn.classList.remove(
        'shoppable-gallery__modal-add-all-btn--loading',
        'shoppable-gallery__modal-add-all-btn--error'
      );
      addAllBtn.classList.add('shoppable-gallery__modal-add-all-btn--success');
      addAllBtn.innerHTML = getAddAllSuccessLabel();

      if (addAllError) addAllError.hidden = true;
    }

    function setAddAllError() {
      if (!addAllBtn) return;

      addAllBtn.disabled = false;
      addAllBtn.classList.remove(
        'shoppable-gallery__modal-add-all-btn--loading',
        'shoppable-gallery__modal-add-all-btn--success'
      );
      addAllBtn.classList.add('shoppable-gallery__modal-add-all-btn--error');
      addAllBtn.innerHTML = getAddAllErrorLabel();

      if (addAllError) addAllError.hidden = false;
    }

    function buildMoneyText(product) {
      if (product.priceText) return product.priceText;
      if (typeof product.price === 'string') return product.price;
      return '';
    }

    function buildOriginalMoneyText(product) {
      if (product.originalPriceText) return product.originalPriceText;
      if (typeof product.originalPrice === 'string') return product.originalPrice;
      return '';
    }

    function buildProductRow(product, productIndex) {
      var row = document.createElement('div');
      row.className = 'shoppable-gallery__modal-product';

      var thumb = document.createElement('div');
      thumb.className = 'shoppable-gallery__modal-product-thumb';

      if (product.thumbnail) {
        var img = document.createElement('img');
        img.src = product.thumbnail;
        img.alt = product.name || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      } else {
        var thumbLabel = document.createElement('span');
        thumbLabel.className = 'shoppable-gallery__modal-thumb-label';
        thumbLabel.textContent = '[Body]';
        thumb.appendChild(thumbLabel);
      }

      var info = document.createElement('div');
      info.className = 'shoppable-gallery__modal-product-info';

      var name = document.createElement('p');
      name.className = 'shoppable-gallery__modal-product-name';
      name.textContent = product.name || '';

      var price = document.createElement('p');
      price.className = 'shoppable-gallery__modal-product-price';
      price.textContent = buildMoneyText(product);

      var originalText = buildOriginalMoneyText(product);
      if (originalText) {
        var original = document.createElement('span');
        original.className = 'shoppable-gallery__modal-original-price';
        original.textContent = originalText;
        price.appendChild(original);
      }

      info.appendChild(name);
      info.appendChild(price);

      var actionWrap = document.createElement('div');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'shoppable-gallery__modal-add-btn js-shoppable-gallery-add-btn';
      btn.setAttribute('data-product-index', productIndex);

      if (product.soldOut || !product.variantId) {
        btn.classList.add('shoppable-gallery__modal-add-btn--soldout');
        btn.disabled = true;
        setButtonText(btn, i18nSoldOut);
      } else {
        setButtonText(btn, i18nAdd);
      }

      var error = document.createElement('p');
      error.className = 'shoppable-gallery__modal-btn-error';
      error.hidden = true;

      actionWrap.appendChild(btn);
      actionWrap.appendChild(error);

      row.appendChild(thumb);
      row.appendChild(info);
      row.appendChild(actionWrap);

      return row;
    }

    function getActiveItem() {
      if (activeIndex === null) return null;
      return galleryData[activeIndex] || null;
    }

    function renderModal(index) {
      var item = galleryData[index];
      if (!item) return;

      activeIndex = index;

      if (titleEl) {
        titleEl.textContent = item.shopTitle || 'Shop the Look';
      }

      if (descEl) {
        descEl.textContent = item.shopDescription || 'Gear used in this shot';
      }

      var prefersMobileImg = false;
      try {
        prefersMobileImg = window.matchMedia('(max-width: 767px)').matches;
      } catch (e) {}

      var modalSrc = (prefersMobileImg && item.srcMobile) ? item.srcMobile : item.src;

      if (modalSrc) {
        modalImg.src = modalSrc;
        modalImg.alt = item.alt || '';
        modalImg.hidden = false;
        if (modalPlaceholder) modalPlaceholder.hidden = true;
      } else {
        modalImg.hidden = true;
        modalImg.removeAttribute('src');
        modalImg.removeAttribute('alt');
        if (modalPlaceholder) modalPlaceholder.hidden = false;
      }

      productsWrap.innerHTML = '';

      var products = Array.isArray(item.products) ? item.products : [];
      var availableProducts = products.filter(function (product) {
        return !product.soldOut && !!product.variantId;
      });

      products.forEach(function (product, productIndex) {
        productsWrap.appendChild(buildProductRow(product, productIndex));
      });

      if (footer) {
        footer.hidden = !(products.length > 0 && availableProducts.length > 0);
      }

      setAddAllIdle();
    }

    function openModal(index) {
      renderModal(index);
      lockBody();
      overlay.hidden = false;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          overlay.classList.add('shoppable-gallery__modal-overlay--open');
        });
      });
    }

    function closeModal() {
      if (overlay.hidden || isClosing) return;

      isClosing = true;
      overlay.classList.remove('shoppable-gallery__modal-overlay--open');

      window.setTimeout(function () {
        overlay.hidden = true;
        activeIndex = null;
        isClosing = false;
        unlockBody();
      }, 600);
    }

    function addItemsToCart(payload) {
      var changeArr = payload.changeArr || [];
      var addArr = payload.addArr || [];
      var tasks = [];
      if (changeArr.length > 0) {
        let updates = {}
        changeArr.forEach(function (item) {
          updates = {
            ...updates,
            [item.id]: item.quantity
          };
        });
        tasks.push(
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
          }).then(function (response) {
            if (!response.ok) {
              return response.json().then(function (errorData) {
                throw errorData;
              });
            }
            return response.json();
          })
        );
      }

      // 新增商品 → add.js（批量提交）
      if (addArr.length > 0) {
        tasks.push(
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: addArr })
          }).then(function (response) {
            if (!response.ok) {
              return response.json().then(function (errorData) {
                throw errorData;
              });
            }
            return response.json();
          })
        );
      }

      return Promise.all(tasks);
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        openModal(index);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openModal(index);
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal();
      });
    }

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) {
        closeModal();
      }
    });

    productsWrap.addEventListener('click', function (event) {
      var button = event.target.closest('.js-shoppable-gallery-add-btn');
      if (!button) return;

      var item = getActiveItem();
      if (!item) return;

      var productIndex = Number(button.getAttribute('data-product-index'));
      var product = item.products && item.products[productIndex];
      if (!product || product.soldOut || !product.variantId) return;

      var errorEl = button.parentNode.querySelector('.shoppable-gallery__modal-btn-error');
      if (errorEl) errorEl.hidden = true;

      setButtonLoading(button, i18nAdding);
      
      var gift = {};
      var itemGiftAttr = {};
      var gifts = product.gifts;
      if (gifts && gifts.length > 0) {
        gifts.forEach(function(g) {
          let qty = Number(g.stock);
          let num = qty - window.getProductStock(product.variantId, g.id);
          if (num > 0) {
            gift[g.id] = num;
          }
          let giftNum = window.getGiftStock(g.id);
          if (giftNum >= qty) {
            gift = {};
          }
        });
        if (Object.keys(gift).length > 0) {
          itemGiftAttr = {
            properties: {
              _gift: JSON.stringify(gift)
            }
          }
        }
      }

      let { url, params } = getCartParams(product.variantId, itemGiftAttr);

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(params)
      })
        .then(function () {
          setSingleButtonSuccess(button);

          var product_name = product.name ? String(product.name).trim() : '';
          activityHeroPushSubscribeEvent('custom_add_to_cart', {
            position: shoppableGalleryTrackingPosition(),
            product_name: product_name,
          });

          if (typeof window.pushGtmAddToCart === 'function') {
            var yhPriShop = product.price ? Number(product.price) / 100 : 0;
            var yhCurShop = window.__shopCurrencyCode || 'USD';
            window.pushGtmAddToCart({
              value: yhPriShop,
              currency: yhCurShop,
              items: [
                {
                  item_id: String(product.variantId || ''),
                  item_name: product_name,
                  currency: yhCurShop,
                  item_brand: '',
                  item_category: '',
                  item_variant: '',
                  price: yhPriShop,
                  quantity: 1,
                  index: 1,
                },
              ],
            });
          }

          window.setTimeout(function () {
            resetSingleButton(button, false);
          }, 1500);

          document.dispatchEvent(new CustomEvent('cart.update'));
        })
        .catch(function (error) {
          console.error('ShoppableGallery add to cart error:', error);
          window.handleCartErrMsg(error);

          setSingleButtonError(button);
          if (errorEl) errorEl.hidden = false;

          window.setTimeout(function () {
            resetSingleButton(button, false);
            if (errorEl) errorEl.hidden = true;
          }, 3000);
        });
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var item = getActiveItem();
        if (!item || !Array.isArray(item.products)) return;

        var availableProducts = item.products.filter(function (product) {
          return !product.soldOut && !!product.variantId;
        });

        if (!availableProducts.length) return;

        setAddAllLoading();

        var payload = availableProducts.map(function (product) {
          var gift = {};
          var itemGiftAttr = {};
          var gifts = product.gifts;
          if (gifts && gifts.length > 0) {
            gifts.forEach(function(g) {
              let qty = Number(g.stock);
              let num = qty - window.getProductStock(product.variantId, g.id);
              if (num > 0) {
                gift[g.id] = num;
              }
              let giftNum = window.getGiftStock(g.id);
              if (giftNum >= qty) {
                gift = {};
              }
            });
            if (Object.keys(gift).length > 0) {
              itemGiftAttr = {
                properties: {
                  _gift: JSON.stringify(gift)
                }
              }
            }
          }
          return {
            id: product.variantId,
            quantity: 1,
            ...itemGiftAttr
          };
        });

        let changeArr = [];
        let addArr = [];
        payload.forEach(item => {
          let giftAttr = item.properties ? { properties: item.properties } : undefined
          let curProduct = window.getCurrentProduct(item.id, giftAttr);
          if (curProduct) {
            changeArr.push({
              id: curProduct.id,
              quantity: curProduct.quantity,
            });
          } else {
            addArr.push(item);
          }
        });

        addItemsToCart({ changeArr: changeArr, addArr: addArr })
          .then(function () {
            setAddAllSuccess();

            var all_product_name = availableProducts
              .map(function (p) {
                return p && p.name ? String(p.name).trim() : '';
              })
              .filter(Boolean)
              .join(', ');
            activityHeroPushSubscribeEvent('custom_add_all_to_cart', {
              all_product_name: all_product_name,
            });

            if (typeof window.pushGtmAddToCart === 'function') {
              var yhCurAll = window.__shopCurrencyCode || 'USD';
              var yhItemsAll = [];
              var yhTotalAll = 0;
              availableProducts.forEach(function (p, idx) {
                if (!p || !p.variantId) return;
                var pri = p.price ? Number(p.price) / 100 : 0;
                yhTotalAll += pri;
                yhItemsAll.push({
                  item_id: String(p.variantId),
                  item_name: p.name ? String(p.name).trim() : '',
                  currency: yhCurAll,
                  item_brand: '',
                  item_category: '',
                  item_variant: '',
                  price: pri,
                  quantity: 1,
                  index: idx + 1,
                });
              });
              if (yhItemsAll.length) {
                window.pushGtmAddToCart({
                  value: Math.round(yhTotalAll * 100) / 100,
                  currency: yhCurAll,
                  items: yhItemsAll,
                });
              }
            }

            var singleButtons = productsWrap.querySelectorAll('.js-shoppable-gallery-add-btn');
            singleButtons.forEach(function (button) {
              var productIndex = Number(button.getAttribute('data-product-index'));
              var product = item.products[productIndex];

              if (product && !product.soldOut && product.variantId) {
                setSingleButtonSuccess(button);

                window.setTimeout(function () {
                  resetSingleButton(button, false);
                }, 1500);
              }
            });

            window.setTimeout(function () {
              setAddAllIdle();
            }, 1500);

            document.dispatchEvent(new CustomEvent('cart.update'));
          })
          .catch(function (error) {
            console.error('ShoppableGallery add all to cart error:', error);
            window.handleCartErrMsg(error);
            setAddAllError();

            window.setTimeout(function () {
              setAddAllIdle();
            }, 3000);
          });
      });
    }
  });
}

/* =================== TabbedProduct ===================== */
function tabbedProductBodyProductName(body) {
  return body ? activityHeroNormalizeText(body.querySelector('.tabbed-product__name')) : '';
}

function tabbedProductSelectVariantName(select) {
  if (!select || select.selectedIndex < 0) return '';
  var opt = select.options[select.selectedIndex];
  return opt ? activityHeroNormalizeText(opt) : '';
}

/** First enabled option index; if all disabled (all sold out), 0 (first sold-out variant). */
function tabbedProductPreferredSelectIndex(select) {
  if (!select || !select.options.length) return 0;
  for (var i = 0; i < select.options.length; i++) {
    if (!select.options[i].disabled) return i;
  }
  return 0;
}

/* =================== TabbedProduct carousel ===================== */
/** Variant id currently selected in the body's variant dropdown ('' when no dropdown). */
function tabbedProductBodySelectedVariantId(body) {
  if (!body) return '';
  var select = body.querySelector('.js-tabbed-product-select');
  return select && select.value ? String(select.value) : '';
}

/** Load lazyload images / videos that live inside a just-shown carousel. */
function tabbedProductUnveilCarouselMedia(carousel) {
  if (!carousel) return;

  carousel.querySelectorAll('img.lazyload').forEach(function (img) {
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      try {
        window.lazySizes.loader.unveil(img);
        return;
      } catch (e) {}
    }
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');
    if (src) img.src = src;
    if (srcset) img.srcset = srcset;
  });

  carousel.querySelectorAll('video[data-src]').forEach(function (video) {
    var src = video.getAttribute('data-src');
    if (src) video.src = src;
  });
}

/**
 * Click-to-play for the video play button inside a tabbed carousel.
 * Bound once per carousel via event delegation so it also covers tns clones.
 */
function tabbedProductBindPlay(carousel) {
  if (!carousel || carousel.dataset.tabbedPlayBound === 'true') return;
  carousel.dataset.tabbedPlayBound = 'true';

  function findTriggerForVideo(video) {
    if (!video) return null;
    var slide = video.closest('.as-carousel-item');
    return slide ? slide.querySelector('.as-play-trigger') : null;
  }

  carousel.addEventListener('click', function (event) {
    var trigger = event.target.closest('.as-play-trigger');
    if (!trigger) return;

    var slide = trigger.closest('.as-carousel-item');
    var video = slide && slide.querySelector('video');
    if (!video) return;

    var src = video.getAttribute('data-src');
    if (src && !video.getAttribute('src')) {
      video.src = src;
    }

    trigger.classList.add('is-hidden');
    video.play().catch(function () {
      trigger.classList.remove('is-hidden');
    });
  });

  carousel.addEventListener(
    'pause',
    function (event) {
      if (!event.target || event.target.tagName !== 'VIDEO') return;
      var trigger = findTriggerForVideo(event.target);
      if (trigger) trigger.classList.remove('is-hidden');
    },
    true
  );

  carousel.addEventListener(
    'ended',
    function (event) {
      if (!event.target || event.target.tagName !== 'VIDEO') return;
      var trigger = findTriggerForVideo(event.target);
      if (trigger) trigger.classList.remove('is-hidden');
    },
    true
  );
}

/** Initialize tiny-slider on one tabbed carousel; returns the instance (or null). */
function tabbedProductInitCarousel(carousel) {
  if (!carousel) return null;
  tabbedProductBindPlay(carousel);
  if (typeof window.tns !== 'function') return null;
  if (carousel._tabbedTns) return carousel._tabbedTns;

  var slides = carousel.querySelectorAll('.as-carousel-item');
  if (slides.length < 2) return null;

  var instance = window.tns({
    container: carousel.querySelector('.carousel-inner'),
    prevButton: carousel.querySelector('.carousel-control-prev'),
    nextButton: carousel.querySelector('.carousel-control-next'),
    nav: false,
    autoplay: false,
    autoplayButtonOutput: false,
    autoplayHoverPause: true,
    controls: true,
    speed: 600,
    loop: true,
    mode: 'carousel',
    startIndex: 0,
    onInit: function () {
      tabbedProductUnveilCarouselMedia(carousel);
    }
  });

  carousel._tabbedTns = instance;
  return instance;
}

function tabbedProductDestroyCarousel(carousel) {
  if (!carousel || !carousel._tabbedTns) return;
  try {
    carousel._tabbedTns.destroy();
  } catch (e) {}
  carousel._tabbedTns = null;
}

function tabbedProductDestroyBodyCarousels(body) {
  if (!body) return;
  body.querySelectorAll('.js-tabbed-product-carousel').forEach(function (carousel) {
    tabbedProductDestroyCarousel(carousel);
  });
}

/** Show the media item matching variantId, hide the rest (destroying their sliders). */
function tabbedProductSwitchCarousel(body, variantId) {
  if (!body) return;
  var items = body.querySelectorAll('.tabbed-item');
  if (!items.length) return;

  var target = null;
  items.forEach(function (item) {
    var isTarget =
      !!variantId && String(item.getAttribute('data-variant-id')) === String(variantId);
    if (isTarget) {
      target = item;
    } else {
      tabbedProductDestroyCarousel(item);
      item.hidden = true;
    }
  });

  if (!target && items.length) {
    target = items[0];
  }

  if (target) {
    target.hidden = false;
    if (target.classList.contains('js-tabbed-product-carousel')) {
      tabbedProductInitCarousel(target);
    }
    tabbedProductUnveilCarouselMedia(target);
  }
}

/** Set initial hidden state for every media item in a body; optionally start the active one. */
function tabbedProductInitBodyCarousels(body, initSlider) {
  if (!body) return;
  var items = body.querySelectorAll('.tabbed-item');
  if (!items.length) return;

  var variantId = tabbedProductBodySelectedVariantId(body);
  var target = null;

  items.forEach(function (item) {
    var isTarget =
      !!variantId && String(item.getAttribute('data-variant-id')) === String(variantId);
    if (isTarget) {
      target = item;
      item.hidden = false;
    } else {
      tabbedProductDestroyCarousel(item);
      item.hidden = true;
    }
  });

  if (!target && items.length) {
    target = items[0];
    target.hidden = false;
  }

  if (target && initSlider) {
    if (target.classList.contains('js-tabbed-product-carousel')) {
      tabbedProductInitCarousel(target);
    }
    tabbedProductUnveilCarouselMedia(target);
  }
}

function initTabbedProducts() {
  var sections = document.querySelectorAll('.js-tabbed-product');
  if (!sections.length) return;

  sections.forEach(function (section) {
    if (section.dataset.tabbedProductInited === 'true') return;
    section.dataset.tabbedProductInited = 'true';

    var tabsWrap = section.querySelector('.js-tabbed-product-tabs');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.js-tabbed-product-tab'));
    var bodies = Array.prototype.slice.call(section.querySelectorAll('.js-tabbed-product-body'));

    function centerActiveTab(tab) {
      if (!tabsWrap || !tab || window.innerWidth >= 1024) return;

      var elLeft = tab.offsetLeft;
      var elWidth = tab.offsetWidth;
      var containerWidth = tabsWrap.offsetWidth;
      var nextLeft = elLeft - (containerWidth - elWidth) / 2;

      tabsWrap.scrollTo({
        left: nextLeft,
        behavior: 'smooth'
      });
    }

    function setBodyState(body) {
      if (!body) return;

      var select = body.querySelector('.js-tabbed-product-select');
      var comboDesc = body.querySelector('.js-tabbed-product-combo-desc');
      var priceText = body.querySelector('.js-tabbed-product-price-text');
      var originalPrice = body.querySelector('.js-tabbed-product-original-price');
      var learnMore = body.querySelector('.js-tabbed-product-learn-more');
      var addBtn = body.querySelector('.js-tabbed-product-add-btn');

      if (!select) return;

      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return;

      var info = selectedOption.getAttribute('data-info') || '';
      var price = selectedOption.getAttribute('data-price') || '';
      var comparePrice = selectedOption.getAttribute('data-compare-price') || '';
      var productUrl = selectedOption.getAttribute('data-product-url') || '#';
      var variantId = selectedOption.getAttribute('data-variant-id') || '';
      var isDisabled = selectedOption.disabled;

      if (comboDesc) {
        comboDesc.innerHTML = info;
        comboDesc.style.display = info ? '' : 'none';
      }

      if (priceText) {
        priceText.textContent = price;
      }

      if (originalPrice) {
        if (comparePrice) {
          originalPrice.textContent = comparePrice;
          originalPrice.classList.remove('is-hidden');
        } else {
          originalPrice.textContent = '';
          originalPrice.classList.add('is-hidden');
        }
      }

      if (learnMore) {
        learnMore.setAttribute('href', productUrl || '#');
      }

      if (addBtn) {
        var textEl = addBtn.querySelector('.js-tabbed-product-add-btn-text');
        var defaultText = addBtn.getAttribute('data-default-text') || '';
        var soldOutText = addBtn.getAttribute('data-sold-out-text') || '';

        addBtn.setAttribute('data-variant-id', variantId || '');

        var priceCents = selectedOption.getAttribute('data-price-cents') || '';
        if (priceCents) {
          addBtn.setAttribute('data-gtm-price-cents', priceCents);
        }

        if (isDisabled || !variantId) {
          addBtn.disabled = true;
          addBtn.classList.add('is-disabled');
          if (textEl) textEl.textContent = soldOutText;
        } else {
          addBtn.disabled = false;
          addBtn.classList.remove('is-disabled');
          if (textEl) textEl.textContent = defaultText;
        }
      }
    }

    function activateTab(index) {
      var nextBody = bodies[index];
      var nextTab = tabs[index];
      if (!nextBody || !nextTab) return;

      var currentBody = section.querySelector('.js-tabbed-product-body.is-active');
      var currentTab = section.querySelector('.js-tabbed-product-tab.tabbed-product__tab--active');

      if (currentBody === nextBody) {
        centerActiveTab(nextTab);
        return;
      }

      if (currentTab) {
        currentTab.classList.remove('tabbed-product__tab--active');
        currentTab.setAttribute('aria-selected', 'false');
      }

      nextTab.classList.add('tabbed-product__tab--active');
      nextTab.setAttribute('aria-selected', 'true');
      centerActiveTab(nextTab);

      if (currentBody) {
        currentBody.classList.add('tabbed-product__body--fading');
      }

      window.setTimeout(function () {
        bodies.forEach(function (body, bodyIndex) {
          var isTarget = bodyIndex === index;
          body.classList.remove('tabbed-product__body--fading');
          body.classList.toggle('is-active', isTarget);
          body.hidden = !isTarget;
          if (!isTarget) {
            tabbedProductDestroyBodyCarousels(body);
          }
        });

        var targetSelect = nextBody.querySelector('.js-tabbed-product-select');
        if (targetSelect) {
          targetSelect.selectedIndex = tabbedProductPreferredSelectIndex(targetSelect);
        }

        setBodyState(nextBody);
        tabbedProductInitBodyCarousels(nextBody, true);
      }, 150);
    }

    function setButtonLoading(button, isLoading) {
      if (!button) return;

      if (isLoading) {
        button.classList.add('is-loading');
        button.disabled = true;
      } else {
        button.classList.remove('is-loading');
        if (!button.classList.contains('is-disabled')) {
          button.disabled = false;
        }
      }
    }

    function addToCart(variantId, body) {
      let gift = {};
      let giftAttr = {};
      let giftElems = body.querySelectorAll('.as-gift-product-id');
      giftElems.forEach(function(e) {
        let qty = e.dataset.stock;
        let val = e.dataset.id;
        let num = Number(qty) - window.getProductStock(variantId, val);
        if (num > 0) {
          gift[val] = num;
        }

        let giftNum = window.getGiftStock(val);
        if (giftNum >= qty) {
          gift = {};
        }
      })
      if (Object.keys(gift).length > 0) {
        giftAttr = {
          "properties": {
            "_gift": JSON.stringify(gift)
          }
        }
      }

      let { url, params } = getCartParams(variantId, giftAttr);
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(params)
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }
        return response.json();
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        var currentBody = section.querySelector('.js-tabbed-product-body.is-active');
        var nextBody = bodies[index];
        if (currentBody && nextBody && currentBody !== nextBody) {
          var product_name = tabbedProductBodyProductName(nextBody);
          if (product_name) {
            activityHeroPushSubscribeEvent('click_activity_product_tab', {
              product_name: product_name,
            });
          }
        }
        activateTab(index);
      });
    });

    bodies.forEach(function (body) {
      var select = body.querySelector('.js-tabbed-product-select');
      var addBtn = body.querySelector('.js-tabbed-product-add-btn');
      var learnMore = body.querySelector('.js-tabbed-product-learn-more');

      setBodyState(body);
      tabbedProductInitBodyCarousels(body, body.classList.contains('is-active'));

      if (learnMore && learnMore.dataset.tabbedProductLearnTrackBound !== 'true') {
        learnMore.dataset.tabbedProductLearnTrackBound = 'true';
        learnMore.addEventListener('click', function () {
          var position = activityResolveActivitySectionCategory(learnMore);
          var product_name = tabbedProductBodyProductName(body);
          activityHeroPushSubscribeEvent('click_activity_learn_more', {
            position: position,
            product_name: product_name,
          });
        });
      }

      if (select) {
        select.addEventListener('change', function () {
          setBodyState(body);
          tabbedProductSwitchCarousel(body, select.value);
          var product_name = tabbedProductBodyProductName(body);
          var variant_name = tabbedProductSelectVariantName(select);
          if (product_name && variant_name) {
            activityHeroPushSubscribeEvent('click_activity_product_select', {
              product_name: product_name,
              variant_name: variant_name,
            });
          }
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var variantId = addBtn.getAttribute('data-variant-id');
          if (!variantId || addBtn.disabled) return;

          var textEl = addBtn.querySelector('.js-tabbed-product-add-btn-text');
          var defaultText = addBtn.getAttribute('data-default-text') || '';
          var successText = addBtn.getAttribute('data-success-text') || '';

          setButtonLoading(addBtn, true);

          addToCart(variantId, body)
            .then(function () {
              if (textEl) textEl.textContent = successText;
              addBtn.classList.remove('is-loading');

              if (!addBtn.classList.contains('is-disabled')) {
                addBtn.disabled = false;
              }

              var position = activityResolveActivitySectionCategory(section);
              var product_name = tabbedProductBodyProductName(body);
              activityHeroPushSubscribeEvent('custom_add_to_cart', {
                position: position,
                product_name: product_name,
              });

              if (typeof window.pushGtmAddToCart === 'function') {
                var tabSelect = body.querySelector('.js-tabbed-product-select');
                var tabOpt = tabSelect && tabSelect.options[tabSelect.selectedIndex];
                var yhCentsTab = tabOpt
                  ? parseInt(tabOpt.getAttribute('data-price-cents') || '0', 10)
                  : parseInt(addBtn.getAttribute('data-gtm-price-cents') || '0', 10);
                var yhPriTab = (isNaN(yhCentsTab) ? 0 : yhCentsTab) / 100;
                var yhCurTab = window.__shopCurrencyCode || 'USD';
                var tabVid = addBtn.getAttribute('data-variant-id');
                window.pushGtmAddToCart({
                  value: yhPriTab,
                  currency: yhCurTab,
                  items: [
                    {
                      item_id: String(tabVid || ''),
                      item_name: product_name || '',
                      currency: yhCurTab,
                      item_brand: '',
                      item_category: '',
                      item_variant: '',
                      price: yhPriTab,
                      quantity: 1,
                      index: 1,
                    },
                  ],
                });
              }

              document.dispatchEvent(new CustomEvent('cart.update'));

              window.setTimeout(function () {
                if (!addBtn.classList.contains('is-disabled') && textEl) {
                  textEl.textContent = defaultText;
                }
              }, 1500);
            })
            .catch(function (error) {
              console.error('TabbedProduct add to cart error:', error);
              if (textEl) textEl.textContent = defaultText;
              window.handleCartErrMsg(error);
              setButtonLoading(addBtn, false);
            });
        });
      }
    });

    var initialActiveTab = section.querySelector('.js-tabbed-product-tab.tabbed-product__tab--active');
    if (initialActiveTab) {
      centerActiveTab(initialActiveTab);
    }

    var initialActiveBody = section.querySelector('.js-tabbed-product-body.is-active');
    if (initialActiveBody) {
      setBodyState(initialActiveBody);
      tabbedProductInitBodyCarousels(initialActiveBody, true);
    }
  });
}

/* =================== LensCombo ===================== */
var LENS_SWIPE_THRESHOLD = 40;
var LENS_TAB_FADE_MS = 150;
var LENS_CART_RESET_MS = 1500;

function lensComboCenterActiveTab(tabsWrap, tab) {
  if (!tabsWrap || !tab) return;
  var elLeft = tab.offsetLeft;
  var elWidth = tab.offsetWidth;
  var containerWidth = tabsWrap.offsetWidth;
  tabsWrap.scrollLeft = elLeft - (containerWidth - elWidth) / 2;
}

function lensComboGetSlides(split) {
  return split ? split.querySelectorAll('.lens-combo__slide') : [];
}

function lensComboSetSlide(split, index) {
  if (!split) return;
  var slides = lensComboGetSlides(split);
  var n = slides.length;
  if (!n) return;

  var slideIndex = ((index % n) + n) % n;
  slides.forEach(function (slide, i) {
    if (slide.classList.contains('lens-combo__slide--active') && i !== slideIndex) {
      lensComboPauseSlideVideo(slide);
    }
    slide.classList.toggle('lens-combo__slide--active', i === slideIndex);
  });

  split.querySelectorAll('.lens-combo__dot').forEach(function (dot, i) {
    dot.classList.toggle('lens-combo__dot--active', i === slideIndex);
  });

  split._lensCurrentSlide = slideIndex;

  lensComboPlaySlideVideo(slides[slideIndex]);
}

/**
 * Pause the video on a single slide and bring back its play trigger.
 */
function lensComboPauseSlideVideo(slide) {
  if (!slide) return;
  var video = slide.querySelector('video');
  if (!video) return;
  video.pause();
  var trigger = slide.querySelector('.as-play-trigger');
  if (trigger) trigger.classList.remove('is-hidden');
}

/**
 * Pause every video inside a split. Used when leaving a tab so the
 * previous screen's playback stops while its split is hidden.
 */
function lensComboStopSplitVideos(split) {
  if (!split) return;
  lensComboGetSlides(split).forEach(function (slide) {
    lensComboPauseSlideVideo(slide);
  });
}

/**
 * Auto-play the video on a slide when it becomes the active slide.
 * Loads the lazy data-src the first time, hides the play trigger, and
 * falls back to click-to-play if the browser blocks autoplay.
 */
function lensComboPlaySlideVideo(slide) {
  if (!slide) return;
  var video = slide.querySelector('video');
  if (!video || !video.paused) return;

  var src = video.getAttribute('data-src');
  if (src && !video.getAttribute('src')) {
    video.src = src;
  }

  var trigger = slide.querySelector('.as-play-trigger');
  if (trigger) trigger.classList.add('is-hidden');

  var playPromise = video.play();
  if (playPromise && typeof playPromise.then === 'function') {
    playPromise.catch(function () {
      if (trigger) trigger.classList.remove('is-hidden');
    });
  }
}

/**
 * Click-to-play for video slides inside a LensCombo carousel.
 * Bound once per split via event delegation on the track.
 */
function lensComboBindPlay(split) {
  if (!split || split.dataset.lensPlayBound === 'true') return;
  split.dataset.lensPlayBound = 'true';

  var track = split.querySelector('.lens-combo__track');
  if (!track) return;

  function findTriggerForVideo(video) {
    if (!video) return null;
    var slide = video.closest('.lens-combo__slide');
    return slide ? slide.querySelector('.as-play-trigger') : null;
  }

  track.addEventListener('click', function (event) {
    var trigger = event.target.closest('.as-play-trigger');
    if (!trigger) return;

    var slide = trigger.closest('.lens-combo__slide');
    var video = slide && slide.querySelector('video');
    if (!video) return;

    var src = video.getAttribute('data-src');
    if (src && !video.getAttribute('src')) {
      video.src = src;
    }

    trigger.classList.add('is-hidden');
    video.play().catch(function () {
      trigger.classList.remove('is-hidden');
    });
  });

  track.addEventListener(
    'pause',
    function (event) {
      if (!event.target || event.target.tagName !== 'VIDEO') return;
      var trigger = findTriggerForVideo(event.target);
      if (trigger) trigger.classList.remove('is-hidden');
    },
    true
  );

  track.addEventListener(
    'ended',
    function (event) {
      if (!event.target || event.target.tagName !== 'VIDEO') return;
      var trigger = findTriggerForVideo(event.target);
      if (trigger) trigger.classList.remove('is-hidden');
    },
    true
  );
}

function lensComboInitCarousel(split) {
  if (!split || split.dataset.lensCarouselInited === 'true') return;
  split.dataset.lensCarouselInited = 'true';
  split._lensCurrentSlide = 0;
  lensComboBindPlay(split);

  var prevBtn = split.querySelector('.lens-combo__arrow--prev');
  var nextBtn = split.querySelector('.lens-combo__arrow--next');
  var track = split.querySelector('.lens-combo__track');

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      lensComboSetSlide(split, split._lensCurrentSlide - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      lensComboSetSlide(split, split._lensCurrentSlide + 1);
    });
  }

  split.querySelectorAll('.lens-combo__dot').forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(dot.getAttribute('data-index'), 10);
      if (!isNaN(index)) lensComboSetSlide(split, index);
    });
  });

  if (track) {
    var startX = 0;
    var dragging = false;

    track.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
        dragging = true;
      },
      { passive: true }
    );

    track.addEventListener('touchend', function (event) {
      if (!dragging) return;
      dragging = false;
      var dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > LENS_SWIPE_THRESHOLD) {
        lensComboSetSlide(split, split._lensCurrentSlide + (dx < 0 ? 1 : -1));
      }
    });

    track.addEventListener('mousedown', function (event) {
      startX = event.clientX;
      dragging = true;
    });

    track.addEventListener('mouseup', function (event) {
      if (!dragging) return;
      dragging = false;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > LENS_SWIPE_THRESHOLD) {
        lensComboSetSlide(split, split._lensCurrentSlide + (dx < 0 ? 1 : -1));
      }
    });
  }
}

function lensComboActivateTab(root, index) {
  var tabs = root.querySelectorAll('.lens-combo__tab');
  var splits = root.querySelectorAll('.lens-combo__split');
  var tabsWrap = root.querySelector('.lens-combo__tabs');
  var nextTab = tabs[index];
  var nextSplit = splits[index];
  var currentSplit = root.querySelector('.lens-combo__split.active');

  if (!nextTab || !nextSplit) return;
  if (currentSplit === nextSplit) {
    lensComboCenterActiveTab(tabsWrap, nextTab);
    return;
  }

  tabs.forEach(function (tab, i) {
    var isActive = i === index;
    tab.classList.toggle('lens-combo__tab--active', isActive);
    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  if (currentSplit) {
    currentSplit.classList.add('lens-combo__split--fading');
    lensComboStopSplitVideos(currentSplit);
  }

  lensComboCenterActiveTab(tabsWrap, nextTab);

  window.setTimeout(function () {
    splits.forEach(function (split, i) {
      split.classList.remove('lens-combo__split--fading');
      split.classList.toggle('active', i === index);
    });
    lensComboSetSlide(nextSplit, 0);
    lensComboCenterActiveTab(tabsWrap, nextTab);
  }, LENS_TAB_FADE_MS);
}

function lensComboAddToCart(split, variantId) {
  var giftElems = split.querySelectorAll('.as-gift-product-id');
  var gift = {};
  var giftAttr;

  giftElems.forEach(function (el) {
    var qty = el.dataset.stock;
    var val = el.dataset.id;
    var num = Number(qty) - window.getProductStock(variantId, val);
    if (num > 0) {
      gift[val] = num;
    }
    var giftNum = window.getGiftStock(val);
    if (giftNum >= qty) {
      gift = {};
    }
  });

  if (Object.keys(gift).length > 0) {
    giftAttr = {
      properties: {
        _gift: JSON.stringify(gift)
      }
    };
  }

  var cartParams = getCartParams(variantId, giftAttr);
  return fetch(cartParams.url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(cartParams.params)
  }).then(function (response) {
    if (!response.ok) {
      return response.json().then(function (errorData) {
        throw errorData;
      });
    }
    return response.json();
  });
}

function lensComboInitCart(split) {
  if (!split) return;

  var addBtn = split.querySelector('.lens-combo__btn--fill');
  if (!addBtn || addBtn.dataset.lensCartBound === 'true') return;
  addBtn.dataset.lensCartBound = 'true';

  var variantId = addBtn.getAttribute('data-variant-id');
  var i18n = window.activityI18n || {};
  var defaultText = addBtn.getAttribute('data-default-text') || i18n.add || 'Add to Cart';
  var successText = addBtn.getAttribute('data-success-text') || i18n.added || 'Added';
  var soldOutText = addBtn.getAttribute('data-sold-out-text') || i18n.soldOut || 'Sold Out';
  var loadingText = i18n.adding || 'Adding...';
  var retryText = i18n.retry || 'Retry';
  var errorDefault = i18n.pleaseTryAgain || 'Failed to add to cart. Please try again.';

  var errorEl = split.querySelector('.lens-combo__cart-error');
  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.className = 'lens-combo__cart-error';
    errorEl.hidden = true;
    var cartWrap = split.querySelector('.lens-combo__cart-wrapper');
    if (cartWrap) {
      cartWrap.insertBefore(errorEl, cartWrap.firstChild);
    }
  }

  function setCartState(state, errorMsg) {
    addBtn.classList.remove('lens-combo__btn--loading', 'lens-combo__btn--success');

    if (state === 'loading') {
      addBtn.classList.add('lens-combo__btn--loading');
      addBtn.disabled = true;
      addBtn.textContent = loadingText;
      if (errorEl) errorEl.hidden = true;
      return;
    }

    if (state === 'success') {
      addBtn.classList.add('lens-combo__btn--success');
      addBtn.disabled = true;
      addBtn.textContent = successText;
      if (errorEl) errorEl.hidden = true;
      return;
    }

    if (state === 'error') {
      addBtn.disabled = false;
      addBtn.textContent = retryText;
      if (errorEl) {
        errorEl.textContent = errorMsg || errorDefault;
        errorEl.hidden = false;
      }
      return;
    }

    addBtn.disabled = !variantId;
    addBtn.textContent = variantId ? defaultText : soldOutText;
    if (errorEl) errorEl.hidden = true;
  }

  if (!variantId) {
    setCartState('idle');
    return;
  }

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled) return;
    setCartState('loading');

    lensComboAddToCart(split, variantId)
      .then(function () {
        setCartState('success');

        var position = activityResolveActivitySectionCategory(split);
        var product_name = activityHeroNormalizeText(split.querySelector('.lens-combo__name'));
        activityHeroPushSubscribeEvent('custom_add_to_cart', {
          position: position,
          product_name: product_name,
        });

        document.dispatchEvent(new CustomEvent('cart.update'));

        window.setTimeout(function () {
          setCartState('idle');
        }, LENS_CART_RESET_MS);
      })
      .catch(function (error) {
        console.error('LensCombo add to cart error:', error);
        window.handleCartErrMsg(error);
        setCartState('error', error && error.message ? error.message : '');
      });
  });
}

function initLensCombo() {
  var roots = document.querySelectorAll('.lens-combo');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.lensComboInited === 'true') return;
    root.dataset.lensComboInited = 'true';

    var tabs = root.querySelectorAll('.lens-combo__tab');
    var tabsWrap = root.querySelector('.lens-combo__tabs');

    root.querySelectorAll('.lens-combo__split').forEach(function (split) {
      lensComboInitCarousel(split);
      lensComboInitCart(split);
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        lensComboActivateTab(root, index);
      });
    });

    var activeTab = root.querySelector('.lens-combo__tab--active');
    lensComboCenterActiveTab(tabsWrap, activeTab);
  });
}
